import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, isRef as _isRef, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createSlots as _createSlots, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/caution_blue.png'
import _imports_1 from '@/assets/image/icon/caution_black.png'
import _imports_2 from '@/assets/image/set-d2c.png'


const _withScopeId = n => (_pushScopeId("data-v-7b0381dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-bwn",
  style: {"margin-top":"16px"}
}
const _hoisted_2 = { style: {"margin-bottom":"8px","display":"flex","align-items":"flex-start","flex-direction":"column"} }
const _hoisted_3 = { class: "flex-ter" }
const _hoisted_4 = { style: {"font-weight":"500","margin-right":"4px","color":"rgba(0, 0, 0, .88)","font-size":"14px"} }
const _hoisted_5 = {
  key: 0,
  style: {"line-height":"22px","margin-top":"-6px"}
}
const _hoisted_6 = {
  key: 0,
  class: "tiktok-warning"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "warning-icon",
  src: "https://static-s.theckb.com/BusinessMarket/Client/api-warning.png",
  alt: ""
}, null, -1))
const _hoisted_8 = { style: {"font-weight":"500","flex":"1"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "【※重要】API連携注文は、", -1))
const _hoisted_10 = { style: {"color":"#27F3EE"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "対応しています。", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","cursor":"pointer"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "caution-icon",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"text-decoration":"underline","margin-right":"10px","color":"#0586FE"} }, " 出荷期限とリスクについて ")
], -1))
const _hoisted_13 = { style: {"padding":"6px","max-width":"480px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"14px","font-weight":"500","display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"height":"16px","margin-right":"4px"},
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 出荷期限とリスクについて： ")
], -1))
const _hoisted_15 = { style: {"color":"rgba(0, 0, 0, 0.65)","margin-top":"6px"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" TikTokでは、ご注文から3営業日以内の出荷が必須です。 遅延によりペナルティやクレームの対象になる可能性があります。")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 納品後でもシステム・物流・政策などの影響で遅延が発生する可能性があります。")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 当社ではこれらによる責任は負いかねますので、あらかじめご了承ください。")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "sync-table" }
const _hoisted_24 = { class: "sync-table-empty-content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/replenish/empty.png",
  alt: ""
}, null, -1))
const _hoisted_26 = { class: "empty-text" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { style: {"padding":"0 4px"} }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { style: {"cursor":"pointer"} }
const _hoisted_32 = { style: {"width":"200px"} }
const _hoisted_33 = { class: "line--3" }
const _hoisted_34 = { class: "tooltip-wrap" }
const _hoisted_35 = { class: "header flex -bwn" }
const _hoisted_36 = { class: "title" }
const _hoisted_37 = { class: "content mt_5" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 2,
  class: "tips tips-en"
}
const _hoisted_41 = { class: "flex-ter" }
const _hoisted_42 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_2,
  style: {"width":"24px","margin-right":"6px"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { style: {"color":"#F5222D"} }
const _hoisted_47 = { class: "no-bind-tip" }
const _hoisted_48 = { class: "icon" }
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { style: {"max-width":"200px","font-size":"12px"} }
const _hoisted_52 = {
  style: {"word-break":"break-word"},
  class: "line--2"
}
const _hoisted_53 = { style: {"word-break":"break-word"} }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_56 = { key: 1 }
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "flex" }
const _hoisted_59 = { style: {"max-width":"200px","font-size":"12px"} }
const _hoisted_60 = {
  style: {"word-break":"break-word"},
  class: "line--2"
}
const _hoisted_61 = { style: {"word-break":"break-word"} }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_64 = { key: 1 }
const _hoisted_65 = ["href"]
const _hoisted_66 = { style: {"padding-left":"108px"} }
const _hoisted_67 = ["src"]
const _hoisted_68 = { style: {"color":"#EB4545"} }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { style: {"width":"200px"} }
const _hoisted_72 = { class: "line--3" }
const _hoisted_73 = {
  key: 0,
  class: "tips"
}
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { key: 2 }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = /*#__PURE__*/_createTextVNode("Tiktok注文")
const _hoisted_88 = { style: {"width":"200px"} }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-wenhao1",
  style: {"font-size":"14px","cursor":"pointer"}
}, null, -1))
const _hoisted_90 = {
  key: 0,
  class: "tips"
}
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["innerHTML"]
const _hoisted_93 = /*#__PURE__*/_createTextVNode("複数倉庫出荷（自動分割）")
const _hoisted_94 = {
  key: 2,
  class: "no-bind-tip"
}
const _hoisted_95 = { class: "icon" }
const _hoisted_96 = {
  key: 3,
  class: "no-bind-tip"
}
const _hoisted_97 = { class: "icon" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = {
  key: 0,
  style: {"cursor":"pointer"}
}
const _hoisted_101 = ["onClick"]
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { class: "line--3" }
const _hoisted_104 = { style: {"max-width":"300px"} }
const _hoisted_105 = {
  key: 0,
  style: {"cursor":"pointer"}
}
const _hoisted_106 = ["onClick"]
const _hoisted_107 = { key: 1 }
const _hoisted_108 = { class: "line--3" }
const _hoisted_109 = { style: {"max-width":"300px"} }
const _hoisted_110 = {
  key: 0,
  style: {"cursor":"pointer"}
}
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { key: 1 }
const _hoisted_113 = { class: "line--3" }
const _hoisted_114 = { style: {"max-width":"300px"} }
const _hoisted_115 = { type: "text" }
const _hoisted_116 = { type: "text" }
const _hoisted_117 = { type: "text" }
const _hoisted_118 = { class: "flex-center" }
const _hoisted_119 = { class: "fx-1" }
const _hoisted_120 = {
  key: 0,
  class: "tips noMagin"
}
const _hoisted_121 = {
  class: "flex-center",
  style: {"margin-top":"4px"}
}
const _hoisted_122 = {
  key: 0,
  class: "fx-1"
}
const _hoisted_123 = {
  key: 0,
  class: "tips noMagin"
}
const _hoisted_124 = {
  class: "flex-center",
  style: {"margin-top":"4px"}
}
const _hoisted_125 = {
  key: 0,
  class: "fx-1"
}
const _hoisted_126 = {
  key: 0,
  class: "tips noMagin"
}
const _hoisted_127 = { class: "tooltip-wrap" }
const _hoisted_128 = { class: "header flex -bwn" }
const _hoisted_129 = { class: "title" }
const _hoisted_130 = { class: "content mt_5" }
const _hoisted_131 = ["innerHTML"]
const _hoisted_132 = { key: 1 }
const _hoisted_133 = { style: {"padding":"20px","margin":"0 auto"} }
const _hoisted_134 = { class: "dialog-footer" }

import { COUNTRY } from '@/global'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { codeName } from '@/components/BlackGoods/data'
import { t, apiText, text as codeMsg } from '@/plugins/i18n'
import { isD2C, useRtfix, useSite2Station, useSite, isEN, useRtAffix, getCustomerShopPlatform, isJA, isMultiStore, getWarehouseCode, getWarehouseCodes, getWarehouseByCountry, isJpPurchaseHasTikTok } from '@/store'
import { ref, Ref, reactive, computed, nextTick, toRaw, watch, getCurrentInstance, h, onMounted, onUnmounted } from 'vue'
import STable from '@/components/Table/index.vue'
import SSearch from './Search.vue'
import ShoppingPreview from '@/components/common/ShoppingPreviewLazy.vue'
import ADialog from './ADialog.vue'
import AddressConfig from './AddressConfig.vue'
import BDialog from '../OrderList/BDialog.vue'
import Guide from '@/components/guide/index.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import CommonTip from '@/components/CommonTip/index.vue'
import RestockBtn from './components/RestockBtn.vue'
import dayjs from "dayjs"

import {
  editableTabs,
  columns,
  columnsed,
  tableConfig,
  childColumns,
  replenishChildColumns,
  childConfig,
  childApiConfig,
  shopOrderPurchaseStatusDict,
  shopProductSkuBindStatusDict,
  getAreaTxt,
  getCityTxt,
  adverseRisk,
  combinConfig,
  comConfig,
  comChildColumns,
  replenishComChildColumns
} from './data'
import useTabData from '@/util/useTabData'
import {
  setNoEmptyForm,
  getJapanTime,
  setStartDateTime,
  setEndDateTime
} from '@/util/common'
import { ElMessage, ElMessageBox } from 'element-plus'
import { autoOrder, getExpressAllCountryListApi, throughCountryGetExpressApi, editIntShipConfigApi } from '@/apis/user'
import {
  pageSyncOrderList,
  deleteShopOrder,
  getCustomerShop,
  getShopOrderProductList,
  createShopOrder,
  editDeliveryAdditions,
  updateSynLogisticsNoApi,
  delShopOrderProduct,
  apiEditAdditionApi,
  batchQueryCombinationProduct,
  getApiOrderCountApi,
  isShowShopifyTitleApi,
  batchUpdateSyncLogisticsApi,
  getOrderGoodsDetailApi,
  getMissingItemOrderFlagApi,
  queryWaitReplenishShopOrderApi,
  getWaitReplenishShopOrderItemListApi
} from '@/apis/order'
import { combinationAddCart, getCombinationList } from '@/apis/combined'
import { addCart as addCartApi, getCartAmount, defectiveProductRiskFlag, updateProductRisk, canUseOnTheWayStockApi } from '@/apis/shopcart'
import { getDeli, getAdt, setAdt } from '@/util/calcAdt'
import { area } from '@/util/useData'
import DeliAdt from '@/components/additional/DeliAdt.vue'
import { useRoute, useRouter } from 'vue-router'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import ConfirmOrder from './ConfirmOrder.vue'
import ConfirmStockInTransitModal from './ConfirmStockInTransitModal.vue'
import ConfirmStocOneClickkModal from './ConfirmStocOneClickkModal.vue'
import { useStore } from 'vuex'
import SyncOrderLimit from '@/views/authorized/AuthorizedStore/SyncOrderLimit.vue'
import TipsPopover from './TipsPopover.vue'
import { Warning, CircleClose, ArrowRight } from '@element-plus/icons-vue'
import RiskArgeement from '@/views/shopcart/components/RiskArgeement.vue'
import { getAreaList, getTotalCountryList } from '@/util/useCountry'
import { getShopLogistics } from '@/apis/setup'
import TermModal from '@/components/termModal/index.vue'
import { getEffectTermByType } from '@/apis/login'
import { jpWareInfo, ShopType, Term, countryCodeNameMap } from '@/common/const'
import ExpressesSelect from './expressesSelect.vue'
import oneClickDialog from './oneClickDialog.vue'
import oneClickConfirmDialog from './oneClickConfirmDialog.vue'
import confirmDialog from '@/components/common/ConfirmDialog'
import { hasAvailableTransportationNums } from '@/apis/stock'
import ExpressSelect from '@/components/ExpressSelect/index.vue'
import ChooseSetAdditon from '@/views/product/AssociatedProductlib/components/ChooseSetWarehouse.vue'
import ManualModal from '@/components/manual/modal.vue'
import { request } from '@/config/request/interceptors'
import Tabs from './components/Tabs.vue'
import MoreWarehouse from './MoreWarehouse.vue'
import { CustomerShopRespDTO, ShopPurchaseRespDTO } from '@/service/customer'
import { req } from '@/plugins/axios'
import { WaitReplenishQuantityRespDTO } from '@/service/order'
import { isTkWhiteUserApi } from '@/apis/api'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const tabsRef = ref()
// 多仓配置

const countryCode = ref(COUNTRY.CN)
// 子表格字段展示
const orderChildColumns = computed(() => {
  const columns = ['2', '3'].includes(tabData.value) ? replenishChildColumns : childColumns
  // 非韩国仓用户过滤国家字段
  if (!isMultiStore()) {
    return columns.filter((v) => v.prop !== 'productCountry')
  }
  return columns
})
const searchRef = ref()
const store = useStore()
const membership = store.getters.membership
const isSub = store.getters.isSub
const splitRemindFlag = computed(() => store.state.route.user.splitRemindFlag)
const SChildTableRefs: Ref<any[]> = ref([])
const status = ref('') // 点击批量下单1  自动下单2  单个下单3

const shopReplenishInfo = computed(() => store.getters.shopReplenishInfo)
const tableWidth = ref(0)
const translateX = ref(0)
const needChangeSize: any = ref('') // 是否需要展示更改尺码
const lazyEle = ref()
/** 当前用户是否可以使用在途库存接口 */
const canUseOnTheWayStock = ref(false)
/** 用于一键下单和单个下单选中的shopids */
const selectedShopids = ref([])
// api海外仓开关
const overSeaSwitch = ref(false)
const isStoreApi = computed(() => store.getters.shopInfo?.customerShopPlatform === 3)

const isTikTokShop = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C())
const moreWarehouseConfig = computed<ShopPurchaseRespDTO>(() => store.getters.moreWareConfig)

const isTikTok = computed(() => (store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C())
// tiktok 关闭多仓，仅中国
const wareOnlyCn = computed(() => (!moreWarehouseConfig.value?.allowMutiWareHouseDelivery) && moreWarehouseConfig.value?.deliveryType === 'ONLY_CN')
const wareOnlyJp = computed(() => (!moreWarehouseConfig.value?.allowMutiWareHouseDelivery) && moreWarehouseConfig.value?.deliveryType === 'ONLY_JP')
// tiktok ，除以上条件外的三个
const openMoreWare = computed(() => moreWarehouseConfig.value?.shopPurchaseId && moreWarehouseConfig.value?.allowMutiWareHouseDelivery)

const curshop = computed(() => store.getters.shopInfo)
console.log(curshop, 'curshop')
const goodsForm = ref({})
const orderStatusDict = {
  UNPAID: t('未支付'),
  ON_HOLD: t('保留中'),
  AWAITING_SHIPMENT: t('待发货'),
  PARTIALLY_SHIPPING: t('部分发货'),
  AWAITING_COLLECTION: t('待揽收'),
  IN_TRANSIT: t('运输中'),
  DELIVERED: t('已送达'),
  COMPLETED: t('已完结'),
  CANCELLED: t('已取消')
}

const changeRestock = () => {
  /** 判断用户是否支持在途库存 */
  judgeCanUseOnTheWayStock()
  getShopInfo()
}
/** 多仓配置获取 */
const getMoreWareConfig = async (isRefresh = false) => {
  store.dispatch('route/changeMoreWareConfig')
  isRefresh && refreshTable(true)
}
const isTkWhiteUser = ref(false)
onMounted(async () => {
  getShopInfo()
  changeTableWidth()
  getExpress()
  /** 判断用户是否支持在途库存 */
  judgeCanUseOnTheWayStock()
  store.dispatch('route/changeMoreWareConfig')
  window.addEventListener('resize', changeTableWidth)
  lazyEle.value = document.querySelector('.user-scroll-container>.el-scrollbar__wrap') || ''
  store.dispatch('status/setShopReplenishInfo')

  isTkWhiteUserApi().then((res) => {
    isTkWhiteUser.value = res.data
  })
})

onUnmounted(() => {
  window.removeEventListener('resize', changeTableWidth)
})
/** 判断是否支持在途库存 */
const judgeCanUseOnTheWayStock = async () => {
  canUseOnTheWayStockApi().then((res) => {
    const data = res.data
    canUseOnTheWayStock.value = data
  }).catch(() => {
    canUseOnTheWayStock.value = false
  })
}

const handlechangeIntShip = (val: any, shopOrderId: any, countryCode: any) => {
  editIntShipConfigApi({
    shopOrderIds: [shopOrderId],
    intShipConfigList: [
      {
        ...(batchExpressList.value.cn.find((v: { intShipConfigId: string }) => v.intShipConfigId === val.cn) ?? {}),
        warehouseCountry: 'CN',
        warehouseCode: getWarehouseCode(false)
      },
      {
        ...(batchExpressList.value.kr.find((v: { intShipConfigId: string }) => v.intShipConfigId === val.kr) ?? {}),
        warehouseCountry: 'KR',
        warehouseCode: getWarehouseCode(true)
      }
    ]
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t(res.msg))
      refreshTable(true)
    } else {
      ElMessage.error(t(res.msg))
    }
  })
}

const BachInfo: any = reactive({
  val: '',
  shopOrderId: '',
  countryCode: ''
})

const handlechangeIntShipBach = (val: any, shopOrderId: any, countryCode: any) => {
  BachInfo.val = val
  BachInfo.shopOrderId = shopOrderId
  BachInfo.countryCode = countryCode
}

const handleClose = () => {
  dialogVisible.value = false
}
// 批量窗口提交
const handleSubmit = () => {
  if (!BachInfo.val.cn && !BachInfo.val.kr && !BachInfo.val.jp) {
    ElMessage.error(t('请选择物流公司'))
    return
  }
  const list = []
  if (BachInfo.val.cn) {
    list.push({
      ...(batchExpressList.value.cn.find((v: { intShipConfigId: string }) => v.intShipConfigId === BachInfo.val.cn) ?? {}),
      warehouseCountry: 'CN',
      warehouseCode: getWarehouseByCountry(COUNTRY.CN)
    })
  }
  if (BachInfo.val.kr) {
    list.push({
      ...(batchExpressList.value.kr.find((v: { intShipConfigId: string }) => v.intShipConfigId === BachInfo.val.kr) ?? {}),
      warehouseCountry: 'KR',
      warehouseCode: getWarehouseByCountry(COUNTRY.KR)
    })
  }
  if (BachInfo.val.jp) {
    list.push({
      ...(batchExpressList.value.jp.find((v: { intShipConfigId: string }) => v.intShipConfigId === BachInfo.val.jp) ?? {}),
      warehouseCountry: COUNTRY.JP,
      warehouseCode: getWarehouseByCountry(COUNTRY.JP)
    })
  }
  editIntShipConfigApi({
    shopOrderIds: BachInfo.shopOrderId,
    intShipConfigList: list
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(res.msg)
      Object.assign(BachInfo, {
        val: '',
        shopOrderId: '',
        countryCode: ''
      })
      refreshTable(true)
      dialogVisible.value = false
    } else {
      ElMessage.error(res.msg)
    }
  })
}

const dialogVisible = ref(false)

const batchExpressList = ref({
  cn: [],
  kr: [],
  jp: []
})
const batchEditExpress = async () => {
  if (selectedOrderList.value.length === 0) {
    ElMessage.warning(t('请选择订单'))
    return
  }

  const countryCodes = selectedOrderList.value.map((item: { receiver: { countryCode: any } }) => item.receiver?.countryCode)
  const isCodeSame = new Set(countryCodes).size === 1
  if (!isCodeSame) {
    ElMessage.warning(t('选择的订单国家不一致'))
  } else {
    // 获取物流列表
    const res = await throughCountryGetExpressApi({
      countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
      systemSource: isD2C() ? 1 : 2,
      warehouseCode: getWarehouseByCountry(COUNTRY.CN)
    })
    if (res.success) {
      const newData = res.data.map((item: { forwarders: any[]; countryCode: any }) => {
        const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
        item.countryCode = [...new Set(countryCodeArray)].join(',')
        return item
      })
      batchExpressList.value.cn = newData
    }
    if (isMultiStore()) {
      const resData = await throughCountryGetExpressApi({
        countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
        systemSource: isD2C() ? 1 : 2,
        warehouseCode: getWarehouseByCountry(COUNTRY.KR)
      })
      if (resData.success) {
        const newData = resData.data.map((item: { forwarders: any[]; countryCode: any }) => {
          const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
          item.countryCode = [...new Set(countryCodeArray)].join(',')
          return item
        })
        batchExpressList.value.kr = newData
      }
    }
    if (openMoreWare.value || wareOnlyJp.value) {
      const res = await throughCountryGetExpressApi({
        countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
        systemSource: isD2C() ? 1 : 2,
        warehouseCode: getWarehouseByCountry(COUNTRY.JP)
      })
      if (res.success) {
        const newData = res.data.map((item: { forwarders: any[]; countryCode: any }) => {
          const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
          item.countryCode = [...new Set(countryCodeArray)].join(',')
          return item
        })
        batchExpressList.value.jp = newData
      }
    }
    dialogVisible.value = true
  }
}

// 中国物流公司
const expresses: any = ref([])
const expressesKr: any = ref([])
const expressesJp: any = ref([])

// 获取当前仓库下所有的物流
const getExpress = () => {
  throughCountryGetExpressApi({
    // countryCode: code,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.CN)
  }).then((res: any) => {
    if (res.success) {
      const newData = res.data.map((item: { forwarders: any[]; countryCode: any }) => {
        const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
        item.countryCode = [...new Set(countryCodeArray)].join(',')
        return item
      })
      expresses.value = newData
    }
    console.log('expresses', expresses.value)
  })
  throughCountryGetExpressApi({
    // countryCode: code,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.KR)
  }).then((res: any) => {
    if (res.success) {
      const newData = res.data.map((item: { forwarders: any[]; countryCode: any }) => {
        const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
        item.countryCode = [...new Set(countryCodeArray)].join(',')
        return item
      })
      expressesKr.value = newData
    }
    console.log('expressesKr', expressesKr.value)
  })
  throughCountryGetExpressApi({
    // countryCode: code,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.JP)
  }).then((res: any) => {
    if (res.success) {
      const newData = res.data.map((item: { forwarders: any[]; countryCode: any }) => {
        const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
        item.countryCode = [...new Set(countryCodeArray)].join(',')
        return item
      })
      expressesJp.value = newData
    }
  })
}

const changeTableWidth = () => {
  // 计算展开table的宽度
  tableWidth.value = document.querySelector('.sync-table')?.clientWidth || 0
}
const handleExpandRow = (val: any, flag: boolean) => {
  if (flag) {
    nextTick(() => {
      SChildTableRefs.value[val.shopOrderId].getData()
    })
  }
}
const handleExpandAll = (val: any, flag: boolean) => {
  if (flag) {
    for (const el of val) {
      nextTick(() => {
        SChildTableRefs.value[el].getData()
      })
    }
  }
}

const selectedOrderList: any = ref([])

// 选择table行
const handleSelectionChange = (val: any) => {
  selectedOrderList.value = val
}

const showAdt: any = ref(false)
const proxy: any = ref(null)
const showOcsa: any = ref(false)
const showOcsaConfirm: any = ref(false)

const deliveryAdditionalList = ref({
  [COUNTRY.CN]: null,
  [COUNTRY.JP]: null,
  [COUNTRY.KR]: null
})

const deliveryAdditionCountryCode = ref<COUNTRY>(COUNTRY.CN)
const openAdt = async (row: any, countryCode: COUNTRY) => {
  deliveryAdditionCountryCode.value = countryCode
  rowItem.value = row

  const addtions = {
    [COUNTRY.CN]: row.deliveryAdditionCn.deliveryAdditionalList,
    [COUNTRY.KR]: row.deliveryAdditionKr.deliveryAdditionalList,
    [COUNTRY.JP]: row.deliveryAdditionJp.deliveryAdditionalList
  }
  const list = await getAdt(addtions[countryCode], 1, getWarehouseByCountry(countryCode))
  proxy.value = list.length ? list : deliveryAdditionalList.value[countryCode]
  showAdt.value = true
}
// 一键设置追踪番号
const oneClickSetupAuto = () => {
  if (selectedOrderList.value.length === 0) {
    ElMessage.warning(t('请选择订单'))
    return
  }
  // console.log('list', selectedOrderList.value)
  showOcsa.value = true
}

const oneClickHandleSuccess = (data: any) => {
  const isNotTipsOneClickConfirm: any = ref(false)
  const customerId = store.getters.user?.mainCustomerId

  // 获取已有的customerId数组，如果没有则创建一个空数组
  const existingIdsString = localStorage.getItem('isNotTipsOneClickConfirms')
  const existingIds = existingIdsString ? JSON.parse(existingIdsString) : []

  // 检查customerId是否已存在于数组中
  // console.log('2222', existingIds, customerId)
  if (existingIds.includes(customerId)) {
    isNotTipsOneClickConfirm.value = true
  }

  if (data.status === '0') {
    showOcsa.value = false
    isNotTipsOneClickConfirm.value ? oneClickConfirmHandleSuccess(data) : showOcsaConfirm.value = true
  } else {
    showOcsa.value = false
    batchChangeStatus(data.status, selectedOrderList.value.map((v: any) => { return v.shopOrderId }))
  }
}

const oneClickConfirmHandleSuccess = (data: any) => {
  console.log(data.status, selectedOrderList.value)
  if (data.status === '0') {
    showOcsaConfirm.value = false
    batchChangeStatus(data.status, selectedOrderList.value.map((v: any) => { return v.shopOrderId }))
  }
}

const batchChangeStatus = (status: any, ids: any) => {
  batchUpdateSyncLogisticsApi({
    shopOrderIds: ids,
    status: status
  }).then(() => {
    refreshTable()
  })
}

const chooseVisible = ref(false)
const openChooseSet = () => {
  if (selectedOrderList.value.length === 0) {
    ElMessage.warning(t('请选择订单'))
    return
  }

  if (isMultiStore() || openMoreWare.value) {
    chooseVisible.value = true
    return
  }
  if (wareOnlyCn.value) {
    batchEditAddition(COUNTRY.CN)
    return
  }
  if (wareOnlyJp.value) {
    batchEditAddition(COUNTRY.JP)
    return
  }
  batchEditAddition(COUNTRY.CN)
}

const batchEditAddition = (countryCode: COUNTRY) => {
  console.log('batchEditAddition', countryCode)
  deliveryAdditionCountryCode.value = countryCode
  rowItem.value = {}
  proxy.value = []
  showAdt.value = true
}
const handleAdt = () => {
  editDeliveryAdditions({
    deliveryAdditions: proxy.value,
    shopOrderIds: rowItem.value.shopOrderId ? [rowItem.value.shopOrderId] : selectedOrderList.value.map((v: any) => { return v.shopOrderId }),
    warehouseCode: getWarehouseByCountry(deliveryAdditionCountryCode.value)
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('发货附加项编辑成功'))
      showAdt.value = false
      refreshTable()
    }
  })
}

const createOrderLoading = ref(false)
// 批量下单
const createOrder = async (useOneTheWayInventory?: boolean) => {
  // 一件代发下单 数量不足
  if (selectedOrderList.value.find((i: { errorCode: string }) => i.errorCode === '240000014')) {
    await confirmOneSaleOrder()
  }
  let isPass = true
  selectedOrderList.value.forEach((row: any) => {
    if (openMoreWare.value || wareOnlyJp.value) {
      if (!checkExpress(row.intShipConfigJp.intShipConfigId, expressesJp.value, row.receiver?.countryCode)) {
        isPass = false
      }
    } else {
      if (!checkExpress(row.intShipConfigCn.intShipConfigId, expresses.value, row.receiver?.countryCode)) {
        isPass = false
      }
    }
    // 判断是否选择物流
    if (row.productCountries.includes('KR')) {
      if (!checkExpress(row.intShipConfigKr.intShipConfigId, expressesKr.value, row.receiver.countryCode)) {
        isPass = false
      }
    }
  })
  if (!isPass) {
    ElMessage.warning(t('默认物流不可发该国家，请重新选择'))
    return
  }
  createOrderLoading.value = true
  //   下单
  createShopOrder({
    shopOrderIds: selectedOrderList.value.map((e: any) => e.shopOrderId),
    useOneTheWayInventory
  })
    .then((res: any) => {
      if (res.success) {
        ElMessage.success(t('下单成功'))
      } else {
        if (res.data?.[0]?.errCode) {
          ElMessage.warning(codeMsg[res.data?.[0]?.errCode])
        }
      }
      refreshTable(true)
    })
    .finally(() => {
      createOrderLoading.value = false
    })
}

const createOrderRow = async (row: any, useOneTheWayInventory?: boolean) => {
  if (row.errorCode === '240000014') {
    await confirmOneSaleOrder()
  }
  if (openMoreWare.value || wareOnlyJp.value) {
    if (!checkExpress(row.intShipConfigJp.intShipConfigId, expressesJp.value, row.receiver?.countryCode)) {
      ElMessage.warning(t('默认物流不可发该国家，请重新选择'))
      return
    }
  } else {
    if (!checkExpress(row.intShipConfigCn.intShipConfigId, expresses.value, row.receiver?.countryCode)) {
      ElMessage.warning(t('默认物流不可发该国家，请重新选择'))
      return
    }
  }

  // 判断是否选择物流
  if (row.productCountries.includes('KR')) {
    if (!checkExpress(row.intShipConfigKr.intShipConfigId, expressesKr.value, row.receiver.countryCode)) {
      ElMessage.warning(t('默认物流不可发该国家，请重新选择'))
      return
    }
  }
  row.createOrderLoading = true
  createShopOrder({ shopOrderIds: [row.shopOrderId], useOneTheWayInventory })
    .then((res: any) => {
      if (res.success) {
        ElMessage.success(t('下单成功'))
      } else {
        if (res.data?.[0]?.errCode) {
          ElMessage.warning(codeMsg[res.data?.[0]?.errCode])
        }
      }
      refreshTable()
    })
    .finally(() => {
      row.createOrderLoading = false
    })
}

const rowItem = ref()
const addressVisible = ref(false)
const countryList = ref([])
const openAddressVisible = async (row: any) => {
  // 拿订单的韩国中国的物流去查对应国家的并集，如果没有物流默认取当前仓库所有国家

  const totalCountry = await getTotalCountryList()
  const chinaResult = await getExpressAllCountryListApi({
    intShipConfigId: row.intShipConfigCn.intShipConfigId,
    wareCode: getWarehouseCode(false)
  })

  const codes = chinaResult.data.map((i: any) => i.countryCode)
  if (isMultiStore()) {
    const koreaResult = await getExpressAllCountryListApi({
      intShipConfigId: row.intShipConfigKr.intShipConfigId,
      wareCode: getWarehouseCode(true)
    })
    koreaResult.data.map((i: any) => i.countryCode).forEach((item: string) => {
      if (!codes.includes(item)) {
        codes.push(item)
      }
    })
  }
  countryList.value = totalCountry.filter((i: any) => codes.indexOf(i.code) > -1)
  if (isTikTok.value) {
    countryList.value = totalCountry.filter((i: any) => i.code === jpWareInfo.warehouseCountry)
  }
  addressVisible.value = true
  rowItem.value = row
}

const syncVisible = ref(false)
const customerShop = ref<CustomerShopRespDTO>()
const customerShopAutoOrderFlag = ref<number>(0)
/** 是否使用在途库存 */
const isUseOnTheWayStock = ref(false)
const customerShopId = ref()
/** change选择是否使用在途库存 */
const changeTheWayStock = async (val: any) => {
  if (!val) {
    const res = await request.customer.customer.shopGet({})
    if (res.data?.smartReplenishFlag) {
      return ElMessage.error(t('您已经开启智能补货计划，必须使用在途库存'))
    }
  }
  autoOrder({ customerShopId: customerShop.value?.customerShopId, customerShopUseOnTheWayStockFlag: Number(val), customerShopAutoOrderFlag: 1 })
    .then((res) => {
      if (res.success) {
        isUseOnTheWayStock.value = val
        // 需要刷新数据
        refresh(true)
      }
    }).catch(() => {
      isUseOnTheWayStock.value = false
    })
}

const getShopInfo = () => {
  request.customer.customer.shopGet({}).then((res) => {
    if (res.success) {
      customerShop.value = res.data
      // 初始化在途库存的值
      isUseOnTheWayStock.value = Boolean(res.data?.customerShopUseOnTheWayStockFlag)
      customerShopAutoOrderFlag.value = res.data?.customerShopAutoOrderFlag
    }
  })
}

const autoOrderLoading = ref(false)
const handleSwitch = (val: any, type?: string) => {
  customerShopId.value = val.customerShopId
  if (type === 'edit') {
    confirmStockInTransitModal.value.open(isUseOnTheWayStock.value)
    return
  }
  console.log(88888, val.customerShopId)
  if (!customerShopAutoOrderFlag.value) {
    defectiveProductRiskFlag().then((res: any) => {
      if (res.code === '0') {
        productRiskFlag.value = res.data
        if (!res.data) {
          // argeeVisiable.value = true
          // riskArgeement.value.sendCode() // 倒计时 5s
          catTerm()
          //   todo
          return
        }
        // 当该用户可以使用在途库存时
        if ((canUseOnTheWayStock.value && !isTikTok.value) || isJpPurchaseHasTikTok()) {
          confirmStockInTransitModal.value.open()
          return
        }
        autoPlaceOrder()
      }
    })
    return
  }
  autoPlaceOrder()
}
// 开启自动下单
const autoPlaceOrder = async (isUseOnTheWayStocks?: boolean, isEdit?: boolean) => {
  autoOrderLoading.value = true
  if (!customerShopAutoOrderFlag.value && !isUseOnTheWayStocks) {
    const res = await request.customer.customer.shopGet({})
    if (res.data?.smartReplenishFlag) {
      autoOrderLoading.value = false
      return ElMessage.error(t('您已经开启智能补货计划，必须使用在途库存'))
    }
  }
  request.customer.customer.shopAutoOrderSwitch({ customerShopId: customerShop.value?.customerShopId, customerShopUseOnTheWayStockFlag: Number(isUseOnTheWayStocks), customerShopAutoOrderFlag: isEdit ? 1 : Number(!customerShopAutoOrderFlag.value), smartReplenishFlag: shopReplenishInfo.value?.smartReplenishFlag, replenishTimeList: shopReplenishInfo.value.replenishTimeList })
    .then((res) => {
      if (res.success) {
        if (customerShopAutoOrderFlag.value) {
          ElMessage.success(t('自動発注をOFFにしました。'))
        } else {
          ElMessage.success(t('自動発注をONにしました。'))
        }
        customerShopAutoOrderFlag.value = Number(!customerShopAutoOrderFlag.value)
        isUseOnTheWayStock.value = Boolean(isUseOnTheWayStocks)
        refresh(true)
      }
    })
    .finally(() => {
      autoOrderLoading.value = false
    })
  confirmStockInTransitModal.value.cancel()
}

const delOrder = (row: any) => {
  row.delLoading = true
  deleteShopOrder({ shopOrderIds: [row.shopOrderId] })
    .then((res: any) => {
      if (res.success) {
        ElMessage.success(t('删除成功'))
        refreshTable()
      }
    })
    .finally(() => {
      row.delLoading = false
    })
}
const router = useRouter()

const addCartFn = (row: any) => {
  console.log(row)
  // 1-普通商品; 2-OEM商品; 3-组合商品"
  if (row.platformItemSku?.productType === 3) {
    // 组合商品
    console.log('组合商品')
    return addSingleCart(row)
  } else if (row.platformItemSku?.productType === 2) {
    return addCartApi({
      oemOrderType: 2,
      searchSourceOrderId: row.platformItemSku.searchSourceOrderId,
      searchSourceOrderCode: row.platformItemSku.searchSourceOrderNo,
      commonProductItemList: [
        {
          cartAdditionList: (row.additionList ?? []).map((e: any) => ({
            additionConfigId: e.additionConfigId,
            ingredientsSku: e.ingredientsSku
          })),
          productSku: row.platformItemSku.productSku,
          orderQuantity: row.itemQuantity
        }
      ]
    } as any)
  } else {
    return addCartApi({
      commonProductItemList: [
        {
          productType: row.platformItemSku?.productType,
          productSku: row.platformItemSku.productSku,
          orderQuantity: row.itemQuantity,
          cartAdditionList: (row.additionList ?? []).map((e: any) => ({
            additionConfigId: e.additionConfigId,
            ingredientsSku: e.ingredientsSku
          }))
        }
      ]
    } as any)
  }
}
const addCart = (row: any) => {
  addCartFn(row).then(async (res: any) => {
    if (res.success) {
      const amount = await getCartAmount().then((res) => res.data)
      ElMessageBox.confirm(
        `
          <div>${t('X件商品已添加至购物车').replace(
          'X',
          row.itemQuantity
        )}</div>
          <div>${t('当前购物车共X种商品').replace('X', amount)}</div>
        `,
        t('添加成功'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: t('去结算'),
          cancelButtonText: t('留在此页'),
          type: 'success'
        }
      ).then(() => {
        router.replace(useRtfix('shopcart', { query: { sc: row.platformItemSku?.productCountry ?? 'CN' } }))
      })
    }
  })
}

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 20
    }
  }
  nextTick(() => {
    translateX.value = 0
    tableWidth.value = document.querySelector('.sync-table')?.clientWidth || 0
    STableRef.value && (STableRef.value.tableData = [])
    STableRef.value && STableRef.value.getData()
  })
  store.dispatch('route/changeMoreWareConfig')
  getOrderNumber()
  tabsRef.value.getCount()
}

const handleSuccess = () => {
  ElMessage.success({
    dangerouslyUseHTMLString: true,
    message: t('订单读取中，预计需要1-3分钟，请稍后刷新页面查看读取结果')
  })
  // setTimeout(() => {
  //   ElMessage.success(t('同步完成-执行刷新'))
  //   refreshTable(true)
  // }, 3000)
}

const refresh = (type?: boolean) => {
  setTimeout(() => refreshTable(type), 3000)
}

const dataList = ref([])
const getData = (val: any) => {
  dataList.value = val
}

const { tabData, orderSyncStatus } = useTabData(
  { TabName: 'orderSyncStatus', defaultValue: '0' },
  () => searchRef.value?.submit()
)

const searchForm: any = ref({})
const filterData = computed(() => {
  return {
    ...setNoEmptyForm({
      ...toRaw(searchForm.value),
      shopOrderStartTime: setStartDateTime(searchForm.value.shopOrderStartTime),
      shopOrderEndTime: setEndDateTime(searchForm.value.shopOrderEndTime),
      queryType: Number(orderSyncStatus.value) === 0 ? 2 : Number(orderSyncStatus.value) === 1 ? 3 : '',
      purchaseCountry: { 2: 'CN', 3: 'JP' }[Number(orderSyncStatus.value)] ?? ''
    })
  }
})

// 补货数量
const replenishQuantity = ref<WaitReplenishQuantityRespDTO>({})
watch(
  () => filterData.value,
  async () => {
    if (filterData.value.customerProductSku || filterData.value.productSku) {
      const res = await request.order.customer.replenishOrderQueryWaitReplenishQuantity({
        ...filterData.value
      })
      replenishQuantity.value = res.data!
    }
  },
  { deep: true }
)

const pageData = ref({
  page: 1,
  limit: 20
})

const provinces = ref()
// 是否白名单用户
const isWhiteUser = ref<boolean>(false)
const init = async () => {
  // provinces.value = await getAreaList({
  //   code: 'JP',
  //   intAreaId: '2279'
  // })
  getDeli(getWarehouseByCountry(COUNTRY.CN)).then((data: any) => {
    deliveryAdditionalList.value[COUNTRY.CN] = data
  })
  getDeli(getWarehouseByCountry(COUNTRY.KR)).then((data: any) => {
    deliveryAdditionalList.value[COUNTRY.KR] = data
  })
  getDeli(getWarehouseByCountry(COUNTRY.JP)).then((data: any) => {
    deliveryAdditionalList.value[COUNTRY.JP] = data
  })
  //  是否白名单用户
  getMissingItemOrderFlagApi({}).then((res: { data: boolean }) => {
    isWhiteUser.value = res.data
  })
}
init()
const delProductItem = (row: any) => {
  row.delItemLoading = true
  delShopOrderProduct({
    shopOrderItemIds: [row.shopOrderItemId]
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('删除成功'))
      handleExpandRow(row, true)
    }
  }).catch(() => { row.delItemLoading = false })
}

// 物流信息弹窗
const inVisible = ref(false)
const international = (row: any) => {
  rowItem.value = toRaw(row)
  inVisible.value = true
}

// 处理采购状态异常
const handleQuestion = (row: any) => {
  switch (row.errorCode) {
    case '1001':
      // 地址信息
      openAddressVisible(row)
      break
    case '1005':
      // 钱包余额不足
      router.push(useRtfix('StoreFund'))
      break
    case '1006':
      // 库存不足
      router.push(useRtfix('stock', { query: { productSkuOrName: row.productSku } }))
      break
  }
}

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    queryType: Number(orderSyncStatus.value) === 0 ? 2 : Number(orderSyncStatus.value) === 1 ? 3 : ''
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}

const changeSwitch = (row: any) => {
  if (row.isReturnLogisticsNo === 0) {
    // 开启
    changeStatus(row)
    return
  }
  ElMessageBox.confirm(t('关闭后将不再向您店铺同步物流单号及订单状态'), t('关闭提醒'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning',
    dangerouslyUseHTMLString: true
  }).then(() => {
    changeStatus(row)
  })
}
const changeStatus = (row: any) => {
  updateSynLogisticsNoApi({
    shopOrderId: row.shopOrderId,
    status: row.isReturnLogisticsNo === 1 ? 0 : 1
  }).then(() => {
    refreshTable()
  })
}

const confirmOrderModal = ref()
/** api下单的在途库存弹窗 */
const confirmStockInTransitModal = ref()
/** 一键下单的在途库存弹窗 */
const confirmStocOneClickkModal = ref()
const argeeVisiable = ref(false) // 是否显示不良品风险提示
const productRiskFlag = ref(false) // true：接受 false：未接受
const riskArgeement = ref()
const placeOrderType = ref(0)
let orderItem = {}
const tipsPopover2 = ref()
// 下单提示
const popverIndex2 = ref(0)
const proxy2 = getCurrentInstance() as any
const closePopver2 = () => {
  proxy2.refs[`memberPop${popverIndex2.value}`].open = false // 关闭tips
}
const confirmOrderFn = async (key: any, item: any) => {
  status.value = key
  orderItem = item
  /** 是否是批量下单 */
  const isSelectedOrderList = selectedOrderList.value.length > 0
  /** 是否有未授权商品 */
  const isBrandListNotAuth = selectedOrderList.value.some((item: any) => item.brandAuthStatus === 0 && item.brandHasReleased === 1)
  const isBrandNotAuth = isSelectedOrderList ? isBrandListNotAuth : orderItem.brandAuthStatus === 0 && orderItem.brandHasReleased === 1

  /** 是否有下架商品 */
  const isBrandListDelist = selectedOrderList.value.some((item: any) => item.brandHasReleased === 1 && item.brandStatus !== 2)
  const isBrandDelist = isSelectedOrderList ? isBrandListDelist : orderItem.brandHasReleased === 1 && orderItem.brandStatus !== 2

  let isNoBind = false
  if (key === '1' && selectedOrderList.value.some((v) => v.partBindFlag)) {
    isNoBind = true
  }
  if (key === '3' && item.partBindFlag) {
    isNoBind = true
  }
  //   没有会员或者会员过期展示的小弹窗
  if (membership.templateLevel === 0) { // 会员过期
    if (key === '3') {
      STableRef.value.tableData.forEach((item: any) => {
        if (proxy2.refs[`memberPop${item.shopOrderId}`]) {
          proxy2.refs[`memberPop${item.shopOrderId}`].open = false
        }
      })
      proxy2.refs[`memberPop${item.shopOrderId}`].open = true // 非会员显示 || 过期会员
      popverIndex2.value = item.shopOrderId
    } else if (key === '1') {
      tipsPopover.value.close()
      tipsPopover3.value.close()
      tipsPopover2.value.open()
    }
    return
  }
  if (isBrandNotAuth) {
    ElMessage.warning(t('存在部分商品未授权，请查看详情并申请授权'))
    return
  } if (isBrandDelist) {
    ElMessage.warning(t('品牌已下架'))
    return
  }
  if (isWhiteUser.value && isNoBind) {
    await confirmDialog({
      title: t('提示'),
      text: t('请确认，只下单已关联商品，未关联商品不会下单'),
      okText: t('确定'),
      cancelText: t('取消'),
      closeOnClickModal: false
    })
  }
  defectiveProductRiskFlag().then(async (res: any) => {
    if (res.code !== '0') return
    productRiskFlag.value = res.data
    if (!res.data) {
      catTerm()
      return
    }
    // 是否需要弹出二次确认弹窗
    if (splitRemindFlag.value === 0) {
      status.value = key
      orderItem = item
      confirmOrderModal.value.open()
      return
    }
    // 根据以前的逻辑key不等于1或者3就没有任何操作
    if (!(key === '1' || key === '3')) {
      return
    }
    // 不管是一键下单还是点击表格中的下单
    let shopOrderIds = []
    if (key === '1') {
      shopOrderIds = selectedOrderList.value?.map(item => item.shopOrderId)
    } else {
      shopOrderIds = [orderItem.shopOrderId]
    }
    const data = await hasAvailableTransportationNums({ shopOrderIds: shopOrderIds })
    // todo  需要加接口，获取在途库存接口，如果有返回数据才需要弹出在途库存的弹窗，否则走以前的逻辑
    // 当该用户可以使用在途库存时
    if (canUseOnTheWayStock.value && Boolean(data?.data) && (!isTikTok.value || isJpPurchaseHasTikTok()) && !customerShop.value?.smartReplenishFlag) {
      //   存放一下
      selectedShopids.value = shopOrderIds
      confirmStocOneClickkModal.value.open()
      return
    }
    // todo
    if (key === '1') {
      createOrder()
      return
    }
    if (key === '3') {
      createOrderRow(item)
    }
  })
}
// 关闭不良风险规约
const closeArgeement = () => {
  argeeVisiable.value = false
}

// 接受不良风险提示
const acceptArgeement = () => {
  updateProductRisk({
    confirmationStyle: 2, // 1： 下单  2：API订单  3：邮箱
    version: '1.0' + '-' + adverseRisk
  }).then(async (res: any) => {
    if (res.code !== '0') return

    argeeVisiable.value = false
    if (customerShopId.value) { // 自动同步下单
      // 当该用户可以使用在途库存时
      if (canUseOnTheWayStock.value && (!isTikTok.value || isJpPurchaseHasTikTok())) {
        confirmStockInTransitModal.value.open()
        return
      }
      autoPlaceOrder()
      return
    }
    if (splitRemindFlag.value === 0) {
      confirmOrderModal.value.open()
      return
    }
    // 看以前的逻辑只有当status.value为1或者3时才有操作
    if (!(status.value === '1' || status.value === '3')) {
      return
    }
    let shopOrderIds = []
    if (status.value === '1') {
      shopOrderIds = selectedOrderList.value?.map(item => item.shopOrderId)
    } else {
      shopOrderIds = [orderItem.shopOrderId]
    }
    // 当该用户可以使用在途库存时
    const data = await hasAvailableTransportationNums({ shopOrderIds: shopOrderIds })
    // todo  需要加接口，获取在途库存接口，如果有返回数据才需要弹出在途库存的弹窗，否则走以前的逻辑
    // 当该用户可以使用在途库存时
    if (canUseOnTheWayStock.value && Boolean(data?.data) && (!isTikTok.value || isJpPurchaseHasTikTok())) {
      //   存放一下
      selectedShopids.value = shopOrderIds
      confirmStocOneClickkModal.value.open()
      return
    }
    if (status.value === '1') {
      createOrder()
      return
    }
    if (status.value === '3') {
      createOrderRow(orderItem)
    }
  })
}

const confirmSuccess = async () => {
  // 1代表一键下单 2代表api下单 3代表单个下单
  //  api同步下单
  if (status.value === '2') {
    handleSwitch(customerShop.value)
    return
  }
  let shopOrderIds = []
  if (status.value === '1') {
    shopOrderIds = selectedOrderList.value?.map(item => item.shopOrderId)
  } else {
    shopOrderIds = [orderItem.shopOrderId]
  }
  //   不管是一键下单还是单个下单，符合条件则直接弹选择在途库存的弹窗
  const data = await hasAvailableTransportationNums({ shopOrderIds: shopOrderIds })
  // todo  需要加接口，获取在途库存接口，如果有返回数据才需要弹出在途库存的弹窗，否则走以前的逻辑
  // 当该用户可以使用在途库存时
  if (canUseOnTheWayStock.value && Boolean(data?.data) && (!isTikTok.value || isJpPurchaseHasTikTok())) {
    //   存放一下
    selectedShopids.value = shopOrderIds
    confirmStocOneClickkModal.value.open()
    return
  }

  if (status.value === '1') {
    createOrder()
    return
  }

  createOrderRow(orderItem)
}
/** api下单在途库存弹窗确认 */
const confirmStockInTransitSuccess = (val: boolean) => {
  autoPlaceOrder(val, true)
}
/** 一键下单在途库存弹窗确认 */
const confirmStocOneClickSuccess = (val: boolean) => {
  // 一键下单
  if (status.value === '1') {
    createOrder(val)
    return
  }
  //   单个订单下单
  createOrderRow(orderItem, val)
}

const tipsPopover = ref()
// 同步订单数据
const syncOrderData = () => {
  if (membership.templateLevel) { // 会员
    syncVisible.value = true
  } else { // 会员过期 || 非会员
    tipsPopover2.value.close()
    tipsPopover3.value.close()
    tipsPopover.value.open()
  }
}
const syncOrderLimit = ref()
const tipsPopover3 = ref()

// 开启自动同步订单
const beforeChangeFn = async () => {
  // if (customerShopAutoOrderFlag.value && !isTikTokShop.value) {
  //   const res = await request.customer.customer.shopGet({})
  //   if (res.data?.smartReplenishFlag) {
  //     ElMessage.error(t('您已经开启智能补货计划，必须使用在途库存'))
  //     return false
  //   }
  // }
  if (membership.templateLevel === 0) { // 会员过期
    syncOrderLimit.value.open()
    tipsPopover.value.close()
    tipsPopover2.value.close()
    tipsPopover3.value.open()
    return false
  }
  if (splitRemindFlag.value === 0 && !customerShopAutoOrderFlag.value) {
    confirmOrderModal.value.open()
    status.value = '2'
    return false
  }

  // 打开自动下单时，且该用户支持在途库存
  if (!customerShopAutoOrderFlag.value && canUseOnTheWayStock.value && (!isTikTok.value || isJpPurchaseHasTikTok())) {
    confirmStockInTransitModal.value.open()
    return false
  }

  return true
}
const popverIndex = ref(0)
const arrPop: Ref<any[]> = ref([])
const cartGoodsItem: any = ref({})
// 修改商品附加项
const editProduct = async (row?: any) => {
  if (membership.templateLevel === 0) { // 非会员
    arrPop.value.push(row.shopOrderItemId)
    popverIndex.value = row.shopOrderItemId
    if (arrPop.value.length === 2) {
      proxy2.refs[`memberPopver${arrPop.value[0]}`].open = false
    } else if (arrPop.value.length >= 3) {
      proxy2.refs[`memberPopver${arrPop.value[1]}`].open = false
      arrPop.value.splice(0, 1)
    }
    proxy2.refs[`memberPopver${row.shopOrderItemId}`].open = true
  } else {
    // 普通商品可以编辑尺码变更
    needChangeSize.value = row?.platformItemSku?.productType === 1 ? 1 : 2
    cartGoodsItem.value = {
      ...row,
      additionSnapshot: row.additionSnapshot,
      noAdditionalFlag: !row.additionCheckType
    }
    countryCode.value = isTikTok.value ? jpWareInfo.warehouseCountry : row.platformItemSku?.productCountry
  }
}
const closePopver = () => {
  proxy2.refs[`memberPopver${popverIndex.value}`].open = false // 关闭tips
}

// 修改商品附加项
const changeAddition = (additionList: any) => {
  // return
  apiEditAdditionApi({
    shopOrderItemId: cartGoodsItem.value.shopOrderItemId,
    needAdditionalFlag: additionList === 1 ? 0 : 1,
    additionList: additionList === 1 ? [] : additionList.map((item: any) => {
      return {
        additionConfigId: item.additionConfigId,
        additionId: item.additionId,
        // TODO additionCode
        additionCode: item.additionCode,
        ingredientsSku: item.ingredientsSku,
        additionName: item.additionName,
        additionNameJp: item.additionNameJp,
        additionExtraName: item.additionExtraName,
        spotCheckFlag: item.spotCheckFlag,
        spotCheckRatio: item.spotCheckRatio
      }
    }),
    warehouseCode: getWarehouseCode(countryCode.value === COUNTRY.KR)
  }).then(() => {
    cartGoodsItem.value = {}
    refreshTable(true)
  })
}

// 不需要附加项
const noAdd = (row: any) => {
  if (row.additionCheckType === 0) return
  apiEditAdditionApi({
    shopOrderItemId: row.shopOrderItemId,
    needAdditionalFlag: 0,
    additionList: [],
    warehouseCode: getWarehouseCode(row.platformItemSku?.productCountry === COUNTRY.KR)
  }).then(() => {
    refreshTable(true)
  })
}

const expandChildOpen = (data: any, row: any) => {
  nextTick(() => {
    SChildTableRefs.value[row.shopOrderId].expandAllChange()
  })
}
const jumpCom = (row: any) => {
  row.loading = true
  getCombinationList({
    keywordSku: row.combinationProductSku,
    pageNum: 1,
    pageSize: 1
  }).then((res: any) => {
    store.commit('goods/CombinedInfo', res?.data.records[0])
    const routeUrl = router.resolve(useRtfix('groupProduct'))
    window.open(routeUrl.href, '_blank')
  }).finally(() => {
    row.loading = false
  })
}

// 组合加入购物车
const addSingleCart = async (e: any) => {
  const combinationProductAdts = await batchQueryCombinationProduct({ combinationProductSkus: [e?.platformItemSku?.productSku], withSubProduct: 1 })
  return await addComCart([{
    combinationProductItemList: e.combinationSubSnapshot,
    combinationProductSku: e?.platformItemSku?.productSku,
    num: 1,
    combinationProductAdt: combinationProductAdts.data[0].combinationProductItems || []
  }])
}
const addComCart = async (data: any) => {
  const list: any = []
  await Promise.all(data.map(async (v: any) => {
    const combinationProductAdts = v.combinationProductAdt
    v.combinationProductItemAddCartList = await Promise.all(
      v.combinationProductItemList.map(async (v: any) => {
        const combinationProductAdtItemCache = combinationProductAdts.filter((y: any) => y.shopProductSku === v.shopProductSku)[0]
        // const combinationProductAdtItem = combinationProductAdtItemCache.length ? {
        //   noAdditionalFlag: 0,
        //   combinationProductItemAdditionList: combinationProductAdtItemCache
        // } : null
        const cartAdditionList = await setAdt(v.productCategoryFrontendNdId, 'combinationProductItemAdditionList', 'noAdditionalFlag', combinationProductAdtItemCache?.additionList, combinationProductAdtItemCache?.noAdditionalFlag)

        // const finalAdt = combinationProductAdtItem || cartAdditionList
        return {
          ...cartAdditionList,
          shopProductSku: v.shopProductSku
        }
      })
    )
    list.push({
      combinationProductItemAddCartList: v.combinationProductItemAddCartList,
      combinationProductSku: v.combinationProductSku,
      num: v.num
    })
  }))
  console.log('iiii', list)
  return combinationAddCart({
    combinationProductSkuList: list
  })
}

const waitPayCount = ref(0)
const getOrderNumber = () => {
  getApiOrderCountApi().then((res: any) => {
    waitPayCount.value = res?.data?.noCreateOrderNum
  })
}
getOrderNumber()

// 是否产生过shopify订单
const isShopify = ref(false)
isShowShopifyTitleApi().then((res: any) => {
  isShopify.value = res.data?.isSubscription || isStoreApi.value
})

const termModalRef = ref()
const term = ref()
const catTerm = async () => {
  //
  const res = await getEffectTermByType({
    stationCode: useSite2Station(),
    type: Term.regular
  })
  term.value = res.data[0]

  // 等待props更新后，在open
  nextTick(termModalRef.value.open)
}
const agreeCallback = () => {
  acceptArgeement()
  termModalRef.value.close()
}

// 一件代发订单下单提示
const confirmOneSaleOrder = async () => {
  await confirmDialog({
    title: t('提示'),
    text: t('当前订单内商品不满足最小起订量，继续下单将以“一件代发”价格下单'),
    okText: t('确认下单'),
    cancelText: t('取消'),
    closeOnClickModal: false
  })
}

const expandFn = async (params: any) => {
  const { shopOrderId, record } = params
  if (['2', '3'].includes(tabData.value)) {
    const list: any = await getWaitReplenishShopOrderItemListApi({
      shopOrderId,
      purchaseCountry: tabData.value === '2' ? 'CN' : 'JP'
    }).then(res => res.data)
    return {
      data: list
    }
  }
  console.log(params, record)
  const goodsList = await getShopOrderProductList({
    shopOrderId: shopOrderId
  }).then((res) => res.data)
  const productCodes: string[] = []
  if (record.errorCode === '240000012') {
    goodsList.forEach((item: any) => {
      if (item.platformItemSku?.productCode) {
        productCodes.push(item.platformItemSku.productCode)
      }
      if (item.platformItemSku?.productType === 3) {
        item.combinationSubSnapshot.forEach((item: any) => {
          if (item.productCode) {
            productCodes.push(item.productCode)
          }
        })
      }
    })
    if (productCodes.length > 0) {
      const goodsDetailList = await getOrderGoodsDetailApi({
        productCodeList: productCodes
      }).then((res: any) => res.data)
      goodsList.forEach((item: any) => {
        if (item.platformItemSku?.productCode) {
          const product = goodsDetailList.find((i: any) => i.productCode === item.platformItemSku?.productCode) ?? {}
          item.platformItemSku.blackTag = product.blackTag
          item.platformItemSku.blackReasonCode = product.blackReasonCode
          item.errorCode = 99
        }
        if (item.platformItemSku?.productType === 3) {
          item.combinationSubSnapshot.forEach((temp: any) => {
            const product = goodsDetailList.find((i: any) => i.productCode === temp.productCode) ?? {}
            temp.blackTag = product.blackTag
            temp.blackReasonCode = product.blackReasonCode
          })
        }
      })
    }
  }
  return {
    data: goodsList
  }
}

const totalColumns = computed(() => {
  let list = (tabData.value === '0' ? columns : columnsed).filter((i: any) => isShopify.value || i.prop !== 'orderName').filter((i) => isMultiStore() || i.prop !== 'deliveryAdditionalList2')
  console.log(store.getters?.shopInfo?.customerShopPlatform, 'store.getters?.shopInfo?.customerShopPlatform ', list)
  const index = list.findIndex((i: any) => i.prop === 'thirdOrderStatus')
  // 只有tiktok订单才有订单状态，不可删除
  if (store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK && tabData.value === '0' && index === -1) {
    const index = list.findIndex((i: any) => i.prop === 'shopOrderNo')
    list.splice(index + 1, 0, {
      label: t('tiktok订单状态'),
      prop: 'thirdOrderStatus',
      slotName: 'thirdOrderStatus',
      width: 120
    })
  }
  if (store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK && isD2C()) {
    const index = list.findIndex((i: any) => i.prop === 'shopOrderTime')
    list.splice(index + 1, 0, {
      label: t('截止发货时间'),
      prop: 'rtsSlaTime',
      slotName: 'rtsSlaTime',
      align: 'center',
      width: 110
    })
  }

  if (wareOnlyCn.value) {
    list = list.filter(i => !['deliveryAdditionalList3'].includes(i.prop))
  }
  if (wareOnlyJp.value) {
    list = list.filter(i => !['deliveryAdditionalList'].includes(i.prop))
  }
  // 中国 日本待补货列表隐藏字段
  list = list.filter((v: any) => {
    if (v.hidden) {
      return !v.hidden.includes(tabData.value)
    }
    return true
  })
  return list.map((i) => {
    if (i.prop === 'orderName') {
      i.label = t('订单') + `(${getCustomerShopPlatform()})`
    }
    if (i.prop === 'deliveryAdditionalList') {
      if (!isMultiStore()) {
        i.label = t('发货附加项')
      }
    }
    return i
  })
})
const jumpDetail = (row: any) => {
  if (row.platformItemSku?.productType === 1) {
    window.open('/goods/' + row.platformItemSku?.productCode, '_blank')
  }
}
const getExpressData = async (item: any, countryCode: string) => {
  const resData = await getShopOrderProductList({
    shopOrderId: item.shopOrderId
  })
  let skuList: any = []
  if (!resData.data.some((i) => i.bindStatus === 0)) {
    resData.data.forEach((v: any) => {
      // 不同国家的物流传不同国家的商品
      if (v.platformItemSku?.productCountry !== countryCode) return
      if (v.platformItemSku.productType === 3) {
        skuList = [...skuList, ...v.combinationSubSnapshot.map((temp: any) => {
          return {
            num: v.itemQuantity * temp.unitNums,
            productSku: temp.productSku,
            productType: temp.productType
          }
        })]
        return
      }
      skuList.push({
        num: v.itemQuantity,
        productSku: v.platformItemSku.productSku,
        productType: v.platformItemSku.productType
      })
    })
  }
  return {
    skuList,
    countryCode: item.receiver?.countryCode,
    systemSource: isD2C() ? 1 : 2
  }
}
const saveExpress = async (item: any, expressItem: any, countryCode?: COUNTRY) => {
  const resData = await editIntShipConfigApi({
    shopOrderIds: [item.shopOrderId],
    intShipConfigList: [
      {
        warehouseCountry: countryCode,
        intShipConfigId: expressItem.intShipConfigId,
        warehouseCode: getWarehouseByCountry(countryCode)
      }
    ]
  })
  if (resData.success) {
    resData.msg && ElMessage.success(t(resData.msg))
    refreshTable(true)
    return true
  } else {
    resData.msg && ElMessage.error(t(resData.msg))
    return false
  }
}
// 判断当前选择的物流是否可以发往对应的国家
const checkExpress = (id: string, express: any[], countryCode: string) => {
  const expressItem = express.find((v: { intShipConfigId: string }) => v.intShipConfigId === id)
  if (expressItem) {
    console.log(expressItem, 'expressItem')

    return expressItem.forwarders?.some((v: { countryCode: string }) => v.countryCode === countryCode)
  }
  return false
}

const jumpOrderDetail = (row: any) => {
  const ids = row.platformOrderList?.map((v) => v.platformOrderId)?.join(',') ?? ''
  const nos = row.platformOrderList?.map((v) => v.platformOrderNo)?.join(',') ?? ''
  if (row.platformOrderList?.length > 1) {
    router.push(useRtfix('OrderList', { query: { type: 1, platformOrderNo: nos } }))
    return
  }
  router.push(useRtfix('OrderInfo', { params: { id: ids }, query: { type: 1 } }))
}
const updatePlan = async () => {
  const { success } = await request.customer.customer.shopManualReplenish()
  if (success) {
    ElMessage.success(t('补货计划手动更新已提交，系统正在处理中，请稍后刷新页面查看结果'))
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CommonTip, {
      name: _unref(isD2C)() ? 'stopPurchaseOrder,stopWarehouse' : 'stopPurchaseOrder'
    }, null, 8, ["name"]),
    _createElementVNode("div", {
      class: _normalizeClass(["order-list", 'sync-order-' + _unref(useSite)()])
    }, [
      _createVNode(SSearch, {
        form: searchForm.value,
        "onUpdate:form": [
          _cache[5] || (_cache[5] = ($event: any) => ((searchForm).value = $event)),
          search
        ],
        isShopify: isShopify.value,
        tabData: _unref(tabData),
        ref: (_value, _refs) => {
          _refs['searchRef'] = _value
          searchRef.value = _value
        },
        isTkWhiteUser: isTkWhiteUser.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_unref(curshop).customerShopPlatform !== 7)
              ? (_openBlock(), _createBlock(TipsPopover, {
                  key: 0,
                  type: 1,
                  ref: (_value, _refs) => {
                    _refs['tipsPopover'] = _value
                    tipsPopover.value = _value
                  }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: syncOrderData
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('同步订单数据')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true),
            _createVNode(TipsPopover, {
              type: 2,
              ref: (_value, _refs) => {
                _refs['tipsPopover2'] = _value
                tipsPopover2.value = _value
              }
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_el_button, {
                  type: "primary",
                  loading: createOrderLoading.value,
                  disabled: !selectedOrderList.value.length,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmOrderFn('1', null)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('一键下单')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]), [
                  [_vShow, _unref(tabData) == 0]
                ])
              ]),
              _: 1
            }, 512),
            _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              onClick: batchEditExpress
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('批量修改物流')), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _unref(tabData) == 0]
            ]),
            _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              onClick: openChooseSet
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('统一编辑发货附加项')), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _unref(tabData) == 0]
            ]),
            (_unref(curshop).customerShopPlatform !== 7)
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: oneClickSetupAuto
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('一键设置追跡番号自動反映')), 1)
                  ]),
                  _: 1
                }, 512)), [
                  [_vShow, _unref(tabData) == 0]
                ])
              : _createCommentVNode("", true),
            (_unref(curshop).customerShopPlatform !== 7)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(_unref(useRtfix)('setupShop', { query: { type: 'ApiAuthSet' } }))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('API自动下单设定')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              onClick: updatePlan
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('手动更新补货计划')), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, ['2', '3'].includes(_unref(tabData)) && _unref(shopReplenishInfo)?.smartReplenishFlag === 1]
            ])
          ]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_space, {
              wrap: "",
              alignment: "flex-start",
              size: 24
            }, {
              default: _withCtx(() => [
                (_unref(curshop).customerShopPlatform !== 7)
                  ? (_openBlock(), _createBlock(TipsPopover, {
                      key: 0,
                      type: 3,
                      ref: (_value, _refs) => {
                        _refs['tipsPopover3'] = _value
                        tipsPopover3.value = _value
                      }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('开启自动同步下单')), 1),
                            _createVNode(_component_el_switch, {
                              loading: autoOrderLoading.value,
                              "model-value": !!customerShopAutoOrderFlag.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (handleSwitch(customerShop.value))),
                              "before-change": beforeChangeFn
                            }, null, 8, ["loading", "model-value"])
                          ]),
                          (!_unref(isTikTok) || _unref(isJpPurchaseHasTikTok)())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (customerShopAutoOrderFlag.value && canUseOnTheWayStock.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createTextVNode(_toDisplayString(isUseOnTheWayStock.value ? _unref(t)('使用在途库存') : _unref(t)('不使用在途库存')) + " ", 1),
                                      _createElementVNode("a", {
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSwitch(customerShop.value, 'edit')))
                                      }, _toDisplayString(_unref(t)('修改')) + ">", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 512))
                  : _createCommentVNode("", true),
                (!_unref(isTikTokShop) || _unref(isJpPurchaseHasTikTok)())
                  ? (_openBlock(), _createBlock(RestockBtn, {
                      key: 1,
                      onChange: changeRestock,
                      onRefresh: _cache[4] || (_cache[4] = ($event: any) => (tabsRef.value.getCount()))
                    }))
                  : _createCommentVNode("", true),
                (_unref(isJA)())
                  ? (_openBlock(), _createBlock(MoreWarehouse, {
                      key: 2,
                      ref: (_value, _refs) => {
                        _refs['moreWarehouseRef'] = _value
                      },
                      onConfirm: getMoreWareConfig,
                      config: _unref(moreWarehouseConfig)
                    }, null, 8, ["config"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(ManualModal, { src: "tiktok#content_0_0" })
          ])
        ]),
        _: 1
      }, 8, ["form", "isShopify", "tabData", "isTkWhiteUser"]),
      (_unref(isJA)() && _unref(isTikTok) && !_unref(isJpPurchaseHasTikTok)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, "事前に" + _toDisplayString((_unref(wareOnlyJp) || _unref(openMoreWare)) ? '日本' : '中国') + "在庫を持っている商品に限り", 1),
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString((_unref(wareOnlyJp) || _unref(openMoreWare)) ? '日本' : '中国') + "在庫がない状態での出荷には対応していないため、必ず先に商品を納品（在庫保有）した上でAPI連携を行ってください。", 1)
            ]),
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "light",
              placement: "bottom-end"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createTextVNode(" そのため、人気商品や販売予定の商品は、事前にTHE CKB" + _toDisplayString(_unref(t)((_unref(wareOnlyJp) || _unref(openMoreWare)) ? '日本仓' : '中国仓')) + " へ納品いただくことを推奨します。", 1),
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(Tabs, {
        tabs: _unref(editableTabs),
        waitPayCount: waitPayCount.value > 99 ? '99+' : waitPayCount.value,
        replenishQuantity: replenishQuantity.value,
        value: _unref(tabData),
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
        ref: (_value, _refs) => {
          _refs['tabsRef'] = _value
          tabsRef.value = _value
        },
        filterData: _unref(filterData)
      }, null, 8, ["tabs", "waitPayCount", "replenishQuantity", "value", "filterData"]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            STableRef.value = _value
          },
          "page-data": pageData.value,
          "onUpdate:page-data": _cache[9] || (_cache[9] = ($event: any) => ((pageData).value = $event)),
          api: ['0', '1'].includes(_unref(tabData)) ? _unref(pageSyncOrderList) : _unref(queryWaitReplenishShopOrderApi),
          filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
          paginationConfig: {
            pageSizes: [10, 20, 200, 500]
          },
          columns: _unref(totalColumns),
          tableConfig: { ..._unref(tableConfig), showHandler: _unref(tabData) === '0' },
          onSelectionChange: handleSelectionChange,
          onExpandRow: handleExpandRow,
          onExpandAll: handleExpandAll,
          onDataListener: getData,
          class: "sync-order-table"
        }, _createSlots({
          rtsSlaTime: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_28, _toDisplayString(row.rtsSlaTime ? _unref(dayjs)(row.rtsSlaTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '-'), 1)
          ]),
          orderStatus: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('已下单')), 1)
          ]),
          expand: _withCtx(({ scope }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({ width: `${tableWidth.value}px`, left: `${translateX.value}px`, position: 'sticky' }),
              class: "rel"
            }, [
              _createVNode(STable, {
                class: "table-son",
                ref: (el) => SChildTableRefs.value[scope.row.shopOrderId] = el,
                api: expandFn,
                filterData: { shopOrderId: scope.row.shopOrderId, record: scope.row },
                columns: _unref(orderChildColumns),
                tableConfig: { ..._unref(childConfig), showHandler: ['0', '1'].includes(_unref(tabData)) },
                apiConfig: _unref(childApiConfig),
                isImmediatelyExec: false,
                showPagination: false,
                onDataListener: (data) => expandChildOpen(data, scope.row)
              }, {
                itemRemark: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(row?.thirdItemSku?.itemRemark || '-'), 1)
                ]),
                addition: _withCtx(({ row }) => [
                  (row?.platformItemSku?.productType === 3 || _unref(isTikTok))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, " - "))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_unref(tabData) === '0')
                          ? _withDirectives((_openBlock(), _createBlock(_component_el_radio, {
                              key: 0,
                              "model-value": !row.additionCheckType,
                              size: "small",
                              label: true,
                              style: {"margin-right":"0"},
                              onChange: ($event: any) => (noAdd(row)),
                              class: "no-check-radio"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                              ]),
                              _: 2
                            }, 1032, ["model-value", "onChange"])), [
                              [_vShow, !row.additionSnapshot?.length]
                            ])
                          : _createCommentVNode("", true),
                        (_unref(tabData) === '1' && !row.additionCheckType && (!row.additionSnapshot || row.additionSnapshot.length === 0))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(t)('不需要检品')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_el_tooltip, {
                            placement: "top",
                            effect: "light"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_32, _toDisplayString((row.additionSnapshot || []).map((v) => v.additionExtra?.additionNameJp).join(',')), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_33, _toDisplayString((row.additionSnapshot || []).map((v) => v.additionExtra?.additionNameJp).join(',')), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (scope.row.shopOrderPurchaseStatus !== 1 && _unref(tabData) === '0')
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                visible: false,
                                placement: "bottom-end",
                                effect: "light",
                                ref: `memberPopver${row.shopOrderItemId}`
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_el_icon, {
                                          color: "#E6A23C",
                                          class: "icon-style",
                                          size: "14px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Warning))
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)('说明')), 1)
                                      ]),
                                      _createVNode(_component_el_icon, {
                                        onClick: closePopver,
                                        color: "#F56C6C",
                                        size: "14px",
                                        style: {"cursor":"pointer"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CircleClose))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      (_unref(isSub) && !_unref(membership).templateLevel)
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 0,
                                            innerHTML: _unref(t)('尊敬的用户，您需办理会员后，方可下单，请联系主账号办理').replace('请联系主账号办理', `<span style='font-weight:bold'>请联系主账号办理</span>`)
                                          }, null, 8, _hoisted_38))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员后，方可下单')), 1))
                                    ]),
                                    _createVNode(_component_router_link, {
                                      to: _unref(useRtfix)('VipLevel')
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, { class: "btn mt_5" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)('办理会员')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["to"])
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "text",
                                    onClick: ($event: any) => (editProduct(row)),
                                    disabled: !row.platformItemSku?.productSku,
                                    class: _normalizeClass({ 'btn-disabled': !row.platformItemSku?.productSku })
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "disabled", "class"])
                                ]),
                                _: 2
                              }, 1536))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(tabData) === '0' && row.additionCheckType && (!row.additionSnapshot || row.additionSnapshot.length === 0))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(t)('请选择附加项2')), 1))
                          : _createCommentVNode("", true),
                        (_unref(openMoreWare))
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 3,
                              effect: "dark",
                              content: _unref(t)('该附加项对于日本仓发货商品不生效'),
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(SvgIcon, {
                                  name: "Tips_提示",
                                  style: {"font-size":"14px"}
                                })
                              ]),
                              _: 1
                            }, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                shoppingInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(ShoppingPreview, {
                      isTikTok: _unref(isTikTok),
                      image: row.thirdItemSku.thirdItemImage || '',
                      name: row.thirdItemSku.thirdItemName || '',
                      url: row.platformItemSku && row.platformItemSku.productCode && _unref(useRtfix)('goods', { params: { id: row.platformItemSku.productCode } }),
                      showStatus: row.errorCode > 0,
                      errorCode: _unref(tabData) === '0' ? row.errorCode : 0,
                      lazyEle: lazyEle.value,
                      product: row
                    }, null, 8, ["isTikTok", "image", "name", "url", "showStatus", "errorCode", "lazyEle", "product"]),
                    (row?.platformItemSku?.productType === 3)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                      : _createCommentVNode("", true)
                  ])
                ]),
                shopProductInfo: _withCtx(({ row }) => [
                  _createElementVNode("p", {
                    class: _normalizeClass([{ 'opacity-5': row.errorCode > 0 }])
                  }, _toDisplayString(row.thirdItemSku.thirdItemAttribute), 3)
                ]),
                bindStatus: _withCtx(({ row }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'opacity-5': row.errorCode > 0 }])
                  }, [
                    (row?.bindStatus)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(shopProductSkuBindStatusDict)[row.bindStatus]) + " ", 1),
                          (row.bindShopProductSku?.errorMessage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_43, "(" + _toDisplayString(row?.errorMessage) + ")", 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_unref(tabData) === '0')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "-"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(t)('未关联')), 1),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(SvgIcon, {
                                      name: "Tips_提示",
                                      style: {"color":"#F5222D","font-size":"14px"}
                                    })
                                  ]),
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)('不通过系统下单')), 1)
                                ])
                              ]))
                        ], 64))
                  ], 2)
                ]),
                itemQuantity: _withCtx(({ row }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'opacity-5': row.errorCode > 0 }])
                  }, _toDisplayString(row.itemQuantity ?? 0) + _toDisplayString(_unref(t)('件')), 3)
                ]),
                shopProductSkuDetail: _withCtx(({ row }) => [
                  (row?.bindStatus == 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{ 'opacity-5': row.errorCode > 0 }])
                      }, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(ShoppingPreview, {
                            image: row.platformItemSku?.productSkuImg || row.platformItemSku?.productMainImg,
                            lazyEle: lazyEle.value,
                            onClick: ($event: any) => (jumpDetail(row))
                          }, null, 8, ["image", "lazyEle", "onClick"]),
                          _createElementVNode("div", {
                            onClick: ($event: any) => (jumpDetail(row))
                          }, [
                            _createVNode(_component_el_tooltip, {
                              effect: "light",
                              placement: "top",
                              "popper-class": "tool-tip-no-border"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_51, _toDisplayString(row.platformItemSku?.productTitle), 1)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_52, _toDisplayString(row.platformItemSku?.productTitle), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("a", _hoisted_53, _toDisplayString((row.platformItemSku?.productPropertiesName || '').split(';').map((e) =>
                            e.replace(/[+-]?\d+:[+-]?\d+:/, '-')).join(' ')), 1)
                          ], 8, _hoisted_50)
                        ]),
                        _createElementVNode("div", null, [
                          (row.brandHasReleased === 1 && row.brandStatus !== 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _hoisted_55,
                                _createVNode(_component_el_tag, { type: "info" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('品牌已下架')), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (row.brandAuthStatus === 0 && row.brandHasReleased === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  (row.isAuthorizing)
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 0,
                                        type: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('申请中')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createVNode(_component_el_tag, { type: "warning" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)('未授权_')), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("a", {
                                          href: _unref(useRtAffix)() + `brandauth?brand=${row.brandId}`,
                                          class: "empower-a"
                                        }, _toDisplayString(_unref(t)('前往授权>')), 9, _hoisted_57)
                                      ], 64))
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ], 2))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: _normalizeClass([{ 'opacity-5': row.errorCode > 0 }])
                      }, "-", 2))
                ]),
                shopProductSkuDetail2: _withCtx(({ row }) => [
                  (row?.bindStatus == 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{ 'opacity-5': row.errorCode > 0 }])
                      }, [
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(ShoppingPreview, {
                            image: row.platformItemSku?.productSkuImg || row.platformItemSku?.productMainImg,
                            lazyEle: lazyEle.value
                          }, null, 8, ["image", "lazyEle"]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_tooltip, {
                              effect: "light",
                              placement: "top",
                              "popper-class": "tool-tip-no-border"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_59, _toDisplayString(row.platformItemSku?.productTitle), 1)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_60, _toDisplayString(row.platformItemSku?.productTitle), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", _hoisted_61, _toDisplayString((row.platformItemSku?.productPropertiesName || '').split(';').map((e) =>
                            e.replace(/[+-]?\d+:[+-]?\d+:/, '-')).join(' ')), 1),
                            _createElementVNode("div", null, _toDisplayString(row.platformItemSku?.productSku), 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          (row.brandHasReleased === 1 && row.brandStatus !== 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _hoisted_63,
                                _createVNode(_component_el_tag, { type: "info" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('品牌已下架')), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (row.brandAuthStatus === 0 && row.brandHasReleased === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  (row.isAuthorizing)
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 0,
                                        type: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('申请中')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createVNode(_component_el_tag, { type: "warning" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)('未授权_')), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("a", {
                                          href: _unref(useRtAffix)() + `brandauth?brand=${row.brandId}`,
                                          class: "empower-a"
                                        }, _toDisplayString(_unref(t)('前往授权>')), 9, _hoisted_65)
                                      ], 64))
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ], 2))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: _normalizeClass([{ 'opacity-5': row.errorCode > 0 }])
                      }, "-", 2))
                ]),
                handler: _withCtx(({ scope: scopeChild }) => [
                  (scopeChild.row.bindStatus == 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_table_button, {
                          title: _unref(t)('加入购物车'),
                          type: "text",
                          onClick: ($event: any) => (addCart(scopeChild.row))
                        }, null, 8, ["title", "onClick"]),
                        (scope.row.orderSyncStatus !== 1)
                          ? (_openBlock(), _createBlock(_component_table_button, {
                              key: 0,
                              title: _unref(t)('修改关联'),
                              type: "text",
                              onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('CreateAssociated', {
                      query: {
                        ..._unref(setNoEmptyForm)({
                          shopItemId: scopeChild.row.thirdItemSku?.shopItemId,
                          // productCode: scopeChild.row.platformItemSku?.productCode
                        })
                      }
                    }
                    )))
                            }, null, 8, ["title", "onClick"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (scope.row.orderSyncStatus !== 1)
                          ? (_openBlock(), _createBlock(_component_table_button, {
                              key: 0,
                              title: _unref(t)('创建关联'),
                              type: "text",
                              onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('CreateAssociated', {
                      query: {
                        shopItemId: scopeChild.row.thirdItemSku?.shopItemId
                      }
                    })))
                            }, null, 8, ["title", "onClick"]))
                          : _createCommentVNode("", true)
                      ], 64)),
                  (scope.row.orderSyncStatus !== 1)
                    ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                        key: 2,
                        "popper-class": "pay-pop",
                        title: _unref(t)('是否确认删除'),
                        onConfirm: ($event: any) => (delProductItem(scopeChild.row))
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_table_button, {
                            title: _unref(t)('删除'),
                            loading: scopeChild.row.delItemLoading,
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                            danger: true
                          }, null, 8, ["title", "loading"])
                        ]),
                        _: 2
                      }, 1032, ["title", "onConfirm"]))
                    : _createCommentVNode("", true)
                ]),
                expand: _withCtx(({ scope: scopeChild }) => [
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(STable, {
                      class: "productTable",
                      ref: (el) => SChildTableRefs.value[scope.row.shopOrderId + scopeChild.row?.platformItemSku?.productSku] = el,
                      tableData: scopeChild.row.combinationSubSnapshot,
                      filterData: { shopOrderId: scope.row.shopOrderId },
                      columns: ['2', '3'].includes(_unref(tabData)) ? _unref(replenishComChildColumns) : _unref(comChildColumns),
                      tableConfig: _unref(comConfig),
                      apiConfig: _unref(childApiConfig),
                      isImmediatelyExec: false,
                      showPagination: false
                    }, {
                      productSkuImg: _withCtx(({ row }) => [
                        _createElementVNode("img", {
                          src: row.productSkuImg,
                          alt: "",
                          style: {"width":"46px"},
                          class: _normalizeClass({ 'disabled-row': row.blackTag === 1 })
                        }, null, 10, _hoisted_67)
                      ]),
                      productTitleJp: _withCtx(({ row }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass([{ 'disabled-row': row.blackTag === 1 }, "line--3"])
                        }, _toDisplayString(row.productTitleJp), 3),
                        _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(codeName)[row.blackReasonCode]?.normal), 1)
                      ]),
                      productPropertiesName: _withCtx(({ row }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'disabled-row': row.blackTag === 1 })
                        }, _toDisplayString(row.productPropertiesName?.replace(/[+-]?\d+:[+-]?\d+:/g, '')), 3)
                      ]),
                      productSku: _withCtx(({ row }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'disabled-row': row.blackTag === 1 })
                        }, _toDisplayString(row.productSku), 3)
                      ]),
                      unitNums: _withCtx(({ row }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass({ 'disabled-row': row.blackTag === 1 })
                        }, _toDisplayString(row.unitNums), 3)
                      ]),
                      additionList: _withCtx(({ row }) => [
                        (_unref(isTikTok))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, "-"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _createVNode(_component_el_tooltip, {
                                placement: "top",
                                effect: "light"
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_71, _toDisplayString((row.additionList || []).map((v) => v.additionExtra?.additionNameJp).join(',')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_72, _toDisplayString((row.additionList || []).map((v) => v.additionExtra?.additionNameJp).join(',')), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (_unref(tabData) === '0' && row.additionCheckType && (!row.additionList || row.additionList.length === 0))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_unref(t)('请选择附加项2')), 1))
                                : _createCommentVNode("", true),
                              (!row.additionCheckType && (!row.additionList || row.additionList.length === 0) && _unref(tabData) === '1')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(_unref(t)('不需要检品')), 1))
                                : _createCommentVNode("", true),
                              (_unref(tabData) === '0')
                                ? _withDirectives((_openBlock(), _createBlock(_component_el_radio, {
                                    key: 2,
                                    "model-value": true,
                                    size: "small",
                                    label: true,
                                    style: {"margin-right":"0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                                    ]),
                                    _: 2
                                  }, 1536)), [
                                    [_vShow, !row.additionCheckType && (!row.additionList || row.additionList.length === 0)]
                                  ])
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, [
                                (_unref(tabData) === '0')
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      type: "text",
                                      onClick: ($event: any) => (jumpCom(row)),
                                      loading: row.loading
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "loading"]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(openMoreWare))
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 3,
                                    effect: "dark",
                                    content: _unref(t)('该附加项对于日本仓发货商品不生效'),
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, { size: "14px" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Warning))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["content"]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      goodsStatus: _withCtx(({ row }) => [
                        ((!row.waitReplenishQuantity && !row.onTheWayFreezeQuantity && !row.freezeQuantity))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, "- "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_76, [
                              (row.waitReplenishQuantity)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_unref(t)('待匹配')) + "(" + _toDisplayString(row.waitReplenishQuantity) + ")", 1))
                                : _createCommentVNode("", true),
                              (row.onTheWayFreezeQuantity)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_unref(t)('在途')) + "(" + _toDisplayString(row.onTheWayFreezeQuantity) + ")", 1))
                                : _createCommentVNode("", true),
                              (row.freezeQuantity)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_unref(t)('匹配良品')) + "(" + _toDisplayString(row.freezeQuantity) + ")", 1))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["tableData", "filterData", "columns", "tableConfig", "apiConfig"])
                  ])
                ]),
                purchaseCountry: _withCtx(({ row }) => [
                  (row.platformItemSku?.productSku)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_unref(countryCodeNameMap).get(row.platformItemSku?.purchaseCountry)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_81, "-"))
                ]),
                goodsStatus: _withCtx(({ row }) => [
                  (row.combinationSubSnapshot?.length || (!row.waitReplenishQuantity && !row.onTheWayFreezeQuantity && !row.freezeQuantity))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, " -"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        (row.waitReplenishQuantity)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(_unref(t)('待匹配')) + "(" + _toDisplayString(row.waitReplenishQuantity) + ")", 1))
                          : _createCommentVNode("", true),
                        (row.onTheWayFreezeQuantity)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_unref(t)('在途')) + "(" + _toDisplayString(row.onTheWayFreezeQuantity) + ")", 1))
                          : _createCommentVNode("", true),
                        (row.freezeQuantity)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_unref(t)('匹配良品')) + "(" + _toDisplayString(row.freezeQuantity) + ")", 1))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _: 2
              }, 1032, ["filterData", "columns", "tableConfig", "apiConfig", "onDataListener"])
            ], 4)
          ]),
          shopOrderNo: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.shopOrderNo), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_el_space, null, {
                default: _withCtx(() => [
                  (row.sampleOrder === 1)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('样品单')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.combinedOrder === 1)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('组合单')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.tiktokOrderFlag && isTkWhiteUser.value)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_87
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          thirdOrderStatus: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(orderStatusDict[row.thirdOrderStatus]), 1)
          ]),
          intShipConfigIdHead: _withCtx(() => [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_unref(t)('国际物流配置')) + " ", 1),
              (_unref(openMoreWare))
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "light",
                    placement: "top"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_88, _toDisplayString(_unref(t)('请注意：关联的商品来自多个国家或多个仓库，会拆成多个订单')), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_89
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          shopOrderTime: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(curshop).customerShopPlatform === 2 && _unref(isJA)() ? row.shopOrderTime : _unref(getJapanTime)(row.shopOrderTime)), 1)
          ]),
          orderSyncStatus: _withCtx(({ row }) => [
            _createElementVNode("p", null, _toDisplayString(_unref(shopOrderPurchaseStatusDict)[_unref(tabData)]), 1),
            (row.errorMessage && row.errorCode !== '1003' && !(_unref(isTikTok) && row.errorCode === '1007'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_90, [
                  (row.errorCode === '1001' || row.errorCode === '1005')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (handleQuestion(row)),
                        style: {"text-decoration":"underline","cursor":"pointer"}
                      }, _toDisplayString(_unref(apiText)[row.errorCode] ?? row.errorMessage), 9, _hoisted_91))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        innerHTML: _unref(apiText)[row.errorCode] ?? row.errorMessage
                      }, null, 8, _hoisted_92))
                ]))
              : _createCommentVNode("", true),
            (_unref(tabData) === '1')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "text",
                  onClick: ($event: any) => (jumpOrderDetail(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('去查看采购订单')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_unref(tabData) === '1' && row.mutiWareHouseDelivery == '1')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_93
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_unref(tabData) === '0' && (row.allUnBindFlag || row.partBindFlag))
              ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createVNode(SvgIcon, {
                      name: "Tips_提示",
                      style: {"color":"#F5222D","font-size":"14px"}
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('部分商品未关联采购链接')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(tabData) === '1' && (row.allUnBindFlag || row.partBindFlag) && isWhiteUser.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    _createVNode(SvgIcon, {
                      name: "Tips_提示",
                      style: {"color":"#F5222D","font-size":"14px"}
                    })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('未关联')) + " " + _toDisplayString(_unref(t)('不通过系统下单')), 1)
                ]))
              : _createCommentVNode("", true),
            (row.errorCode === '240000014')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "set-auth",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push(_unref(useRtfix)('setupShop', { query: { type: 'ApiAuthSet' } }))))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('设置为自动下单，不再询问')), 1),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowRight))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          shopOrderAmount: _withCtx(({ row }) => [
            (_unref(isEN)())
              ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(_unref(t)('円')) + _toDisplayString(row.shopOrderAmount ?? 0), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(row.shopOrderAmount ?? 0) + _toDisplayString(_unref(t)('円')), 1))
          ]),
          quantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.quantity ?? 0) + " " + _toDisplayString(_unref(t)('件')), 1)
          ]),
          deliveryAdditionalList: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              placement: "top",
              effect: "light"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("p", null, _toDisplayString((row.deliveryAdditionCn?.deliveryAdditionalList || []).map((v) =>
                      v.additionNameJp).join(',') || '-'), 1)
                ])
              ]),
              default: _withCtx(() => [
                (!row.orderSyncStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                      _createElementVNode("p", {
                        class: "line--3",
                        onClick: ($event: any) => (openAdt(row, _unref(COUNTRY).CN))
                      }, _toDisplayString((row.deliveryAdditionCn?.deliveryAdditionalList || []).map((v) => v.additionNameJp).join(',')
                    || '-'), 9, _hoisted_101)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_102, [
                      _createElementVNode("p", _hoisted_103, _toDisplayString((row.deliveryAdditionCn?.deliveryAdditionalList || []).map((v) => v.additionNameJp).join(',')
                    || '-'), 1)
                    ]))
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", null, [
              (_unref(tabData) === '0')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: ($event: any) => (openAdt(row, _unref(COUNTRY).CN))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          deliveryAdditionalList2: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              placement: "top",
              effect: "light"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("p", null, _toDisplayString((row.deliveryAdditionKr?.deliveryAdditionalList || []).map((v) =>
                      v.additionNameJp).join(',') || '-'), 1)
                ])
              ]),
              default: _withCtx(() => [
                (!row.orderSyncStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                      _createElementVNode("p", {
                        class: "line--3",
                        onClick: ($event: any) => (openAdt(row, _unref(COUNTRY).KR))
                      }, _toDisplayString((row.deliveryAdditionKr?.deliveryAdditionalList || []).map((v) => v.additionNameJp).join(',')
                    || '-'), 9, _hoisted_106)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                      _createElementVNode("p", _hoisted_108, _toDisplayString((row.deliveryAdditionKr?.deliveryAdditionalList || []).map((v) => v.additionNameJp).join(',')
                    || '-'), 1)
                    ]))
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", null, [
              (_unref(tabData) === '0')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: ($event: any) => (openAdt(row, _unref(COUNTRY).KR))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          deliveryAdditionalList3: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              placement: "top",
              effect: "light"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("p", null, _toDisplayString((row.deliveryAdditionJp?.deliveryAdditionalList || []).map((v) =>
                      v.additionNameJp).join(',') || '-'), 1)
                ])
              ]),
              default: _withCtx(() => [
                (!row.orderSyncStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                      _createElementVNode("p", {
                        class: "line--3",
                        onClick: ($event: any) => (openAdt(row, _unref(COUNTRY).JP))
                      }, _toDisplayString((row.deliveryAdditionJp?.deliveryAdditionalList || []).map((v) => v.additionNameJp).join(',')
                    || '-'), 9, _hoisted_111)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      _createElementVNode("p", _hoisted_113, _toDisplayString((row.deliveryAdditionJp?.deliveryAdditionalList || []).map((v) => v.additionNameJp).join(',')
                    || '-'), 1)
                    ]))
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", null, [
              (_unref(tabData) === '0')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: ($event: any) => (openAdt(row, _unref(COUNTRY).JP))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          receiver: _withCtx(({ row }) => [
            (row.receiver)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_115, _toDisplayString(row.receiver.name) + " " + _toDisplayString(row.receiver.phone), 1),
                  _createElementVNode("p", _hoisted_116, _toDisplayString(row.receiver.country) + " " + _toDisplayString(row.receiver.province) + " " + _toDisplayString(row.receiver.city), 1),
                  _createElementVNode("p", _hoisted_117, _toDisplayString(row.receiver.address), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          intShipConfigId: _withCtx(({ row }) => [
            (row.receiver)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(isMultiStore)() && row.productCountries.includes('KR'))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("span", _hoisted_119, _toDisplayString(_unref(t)('韩国')), 1),
                          _createVNode(ExpressSelect, {
                            id: row.intShipConfigKr.intShipConfigId,
                            "onUpdate:id": ($event: any) => ((row.intShipConfigKr.intShipConfigId) = $event),
                            placeholder: _unref(t)('请选择物流公司'),
                            defaultExpress: expressesKr.value,
                            getData: () => getExpressData(row, _unref(COUNTRY).KR),
                            beforeSave: (id) => saveExpress(row, id, _unref(COUNTRY).KR),
                            "fee-tip": _unref(t)('请先关联商品'),
                            countryCode: _unref(COUNTRY).KR,
                            style: {"width":"200px"}
                          }, null, 8, ["id", "onUpdate:id", "placeholder", "defaultExpress", "getData", "beforeSave", "fee-tip", "countryCode"])
                        ]),
                        (!checkExpress(row.intShipConfigKr.intShipConfigId, expressesKr.value, row.receiver.countryCode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(_unref(t)('默认物流不可发该国家，请重新选择')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(wareOnlyCn) || _unref(openMoreWare))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_121, [
                          (_unref(openMoreWare))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_122, _toDisplayString(_unref(t)('中国')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(ExpressSelect, {
                            id: row.intShipConfigCn.intShipConfigId,
                            "onUpdate:id": ($event: any) => ((row.intShipConfigCn.intShipConfigId) = $event),
                            placeholder: _unref(t)('请选择物流公司'),
                            defaultExpress: expresses.value,
                            getData: () => getExpressData(row, _unref(COUNTRY).CN),
                            beforeSave: (id) => saveExpress(row, id, _unref(COUNTRY).CN),
                            "fee-tip": _unref(t)('请先关联商品'),
                            countryCode: _unref(COUNTRY).CN,
                            style: {"width":"200px"}
                          }, null, 8, ["id", "onUpdate:id", "placeholder", "defaultExpress", "getData", "beforeSave", "fee-tip", "countryCode"])
                        ]),
                        (!checkExpress(row.intShipConfigCn.intShipConfigId, expresses.value, row.receiver.countryCode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, _toDisplayString(_unref(t)('默认物流不可发该国家，请重新选择')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(openMoreWare) || _unref(wareOnlyJp))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_124, [
                          (_unref(openMoreWare))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(_unref(t)('日本')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(ExpressSelect, {
                            id: row.intShipConfigJp.intShipConfigId,
                            "onUpdate:id": ($event: any) => ((row.intShipConfigJp.intShipConfigId) = $event),
                            placeholder: _unref(t)('请选择物流公司'),
                            defaultExpress: expressesJp.value,
                            getData: () => getExpressData(row, _unref(COUNTRY).CN),
                            beforeSave: (id) => saveExpress(row, id, _unref(COUNTRY).JP),
                            "fee-tip": _unref(t)('请先关联商品'),
                            countryCode: _unref(COUNTRY).JP,
                            style: {"width":"200px"}
                          }, null, 8, ["id", "onUpdate:id", "placeholder", "defaultExpress", "getData", "beforeSave", "fee-tip", "countryCode"])
                        ]),
                        (!checkExpress(row.intShipConfigJp.intShipConfigId, expressesJp.value, row.receiver.countryCode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_126, _toDisplayString(_unref(t)('默认物流不可发该国家，请重新选择')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          isReturnLogisticsNo: _withCtx(({ row }) => [
            (_unref(curshop).customerShopPlatform !== 7)
              ? (_openBlock(), _createBlock(_component_el_switch, {
                  key: 0,
                  "model-value": !!row.isReturnLogisticsNo,
                  onClick: ($event: any) => (changeSwitch(row))
                }, null, 8, ["model-value", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          handler: _withCtx(({ scope }) => [
            (!['2', '3'].includes(_unref(tabData)))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_table_button, {
                    title: _unref(t)('编辑物流/地址'),
                    type: "text",
                    onClick: ($event: any) => (openAddressVisible(scope.row))
                  }, null, 8, ["title", "onClick"]),
                  _createVNode(_component_el_tooltip, {
                    visible: false,
                    effect: "light",
                    placement: "bottom-end",
                    ref: `memberPop${scope.row.shopOrderId}`
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_icon, {
                              color: "#E6A23C",
                              class: "icon-style",
                              size: "14px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Warning))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", _hoisted_129, _toDisplayString(_unref(t)('提示')), 1)
                          ]),
                          _createVNode(_component_el_icon, {
                            onClick: closePopver2,
                            color: "#F56C6C",
                            size: "14px",
                            style: {"cursor":"pointer"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CircleClose))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_130, [
                          (_unref(isSub))
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                innerHTML: _unref(t)('尊敬的用户，您需办理会员后，方可下单，请联系主账号办理').replace('请联系主账号办理', `<b>请联系主账号办理</b>`)
                              }, null, 8, _hoisted_131))
                            : (_openBlock(), _createElementBlock("p", _hoisted_132, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员后，方可下单')), 1))
                        ]),
                        _createVNode(_component_router_link, {
                          to: _unref(useRtfix)('VipLevel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, { class: "btn mt_5" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('办理会员')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_table_button, {
                        title: _unref(t)('下单'),
                        type: "text",
                        loading: scope.row.createOrderLoading,
                        disabled: !scope.row.placeOrder,
                        onClick: ($event: any) => (confirmOrderFn('3', scope.row))
                      }, null, 8, ["title", "loading", "disabled", "onClick"])
                    ]),
                    _: 2
                  }, 1536),
                  _createVNode(_component_el_popconfirm, {
                    "popper-class": "pay-pop",
                    title: _unref(t)('是否删除'),
                    onConfirm: ($event: any) => (delOrder(scope.row))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_table_button, {
                        title: _unref(t)('删除'),
                        type: "text",
                        loading: scope.row.delLoading,
                        danger: true
                      }, null, 8, ["title", "loading"])
                    ]),
                    _: 2
                  }, 1032, ["title", "onConfirm"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (['2', '3'].includes(_unref(tabData)))
            ? {
                name: "tableEmpty",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('当前无需补货')), 1),
                      (_unref(shopReplenishInfo)?.replenishTimeList?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "（" + _toDisplayString(_unref(t)('会在每日X定时生成').replace('X',
                  _unref(shopReplenishInfo)?.replenishTimeList?.map(v => _unref(t)('X时').replace('X',
                    v.split(':')[0])).join(','))) + "）", 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              }
            : undefined
        ]), 1032, ["page-data", "api", "filterData", "columns", "tableConfig"]),
        _createVNode(ADialog, {
          visible: syncVisible.value,
          "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((syncVisible).value = $event)),
          onSuccess: handleSuccess
        }, null, 8, ["visible"]),
        _createVNode(oneClickDialog, {
          visible: showOcsa.value,
          "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((showOcsa).value = $event)),
          onSuccess: oneClickHandleSuccess
        }, null, 8, ["visible"]),
        _createVNode(oneClickConfirmDialog, {
          visible: showOcsaConfirm.value,
          "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((showOcsaConfirm).value = $event)),
          onSuccess: oneClickConfirmHandleSuccess
        }, null, 8, ["visible"]),
        _createVNode(AddressConfig, {
          visible: addressVisible.value,
          "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((addressVisible).value = $event)),
          provinces: provinces.value,
          form: rowItem.value,
          onSuccess: refreshTable,
          countryList: countryList.value
        }, null, 8, ["visible", "provinces", "form", "countryList"]),
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            (showAdt.value)
              ? (_openBlock(), _createBlock(AdditionDrawer, {
                  key: 0,
                  cfg: proxy.value,
                  "onUpdate:cfg": [
                    _cache[14] || (_cache[14] = ($event: any) => ((proxy).value = $event)),
                    handleAdt
                  ],
                  onClose: _cache[15] || (_cache[15] = ($event: any) => (showAdt.value = false)),
                  reback: "",
                  type: "DeliAdt",
                  countryCode: deliveryAdditionCountryCode.value
                }, null, 8, ["cfg", "countryCode"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
        _createVNode(BDialog, {
          title: _unref(t)('国际物流单号信息'),
          visible: inVisible.value,
          "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((inVisible).value = $event)),
          rowItem: rowItem.value
        }, null, 8, ["title", "visible", "rowItem"])
      ]),
      _createVNode(Guide, { name: "sync-order" }),
      _createVNode(BatchSearch),
      _createVNode(ConfirmOrder, {
        ref: (_value, _refs) => {
          _refs['confirmOrderModal'] = _value
          confirmOrderModal.value = _value
        },
        onSuccess: confirmSuccess
      }, null, 512),
      _createVNode(ConfirmStockInTransitModal, {
        ref: (_value, _refs) => {
          _refs['confirmStockInTransitModal'] = _value
          confirmStockInTransitModal.value = _value
        },
        onSuccess: confirmStockInTransitSuccess
      }, null, 512),
      _createVNode(ConfirmStocOneClickkModal, {
        ref: (_value, _refs) => {
          _refs['confirmStocOneClickkModal'] = _value
          confirmStocOneClickkModal.value = _value
        },
        onSuccess: confirmStocOneClickSuccess,
        selectedShopids: selectedShopids.value
      }, null, 8, ["selectedShopids"]),
      _createVNode(SyncOrderLimit, {
        ref: (_value, _refs) => {
          _refs['syncOrderLimit'] = _value
          syncOrderLimit.value = _value
        }
      }, null, 512),
      _createVNode(RiskArgeement, {
        visiable: argeeVisiable.value,
        ref: (_value, _refs) => {
          _refs['riskArgeement'] = _value
          riskArgeement.value = _value
        },
        onAcceptArgeement: acceptArgeement,
        onCloseArgeement: closeArgeement
      }, null, 8, ["visiable"]),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (cartGoodsItem.value.additionSnapshot)
            ? (_openBlock(), _createBlock(AdditionDrawer, {
                key: 0,
                list: cartGoodsItem.value.additionSnapshot,
                "onUpdate:list": _cache[17] || (_cache[17] = ($event: any) => ((cartGoodsItem.value.additionSnapshot) = $event)),
                proxy: cartGoodsItem.value,
                onCommit: changeAddition,
                needChangeSize: needChangeSize.value,
                isBackSku: true,
                type: "AdtOrder",
                countryCode: countryCode.value
              }, null, 8, ["list", "proxy", "needChangeSize", "countryCode"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })),
      _createVNode(TermModal, {
        ref: (_value, _refs) => {
          _refs['termModalRef'] = _value
          termModalRef.value = _value
        },
        title: _unref(t)('次转正提醒'),
        fileUrl: term.value?.fileUrl,
        disableBtn: true,
        timer: true,
        ondisAgree: agreeCallback
      }, null, 8, ["title", "fileUrl"]),
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((dialogVisible).value = $event)),
        title: _unref(t)('批量修改物流'),
        width: "30%",
        "custom-class": "Expresses-confirm-dialog",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_134, [
            _createVNode(_component_el_button, {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (handleClose()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (handleSubmit()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_133, [
            _createVNode(ExpressesSelect, {
              config: _unref(moreWarehouseConfig),
              isTiktok: _unref(isTikTok),
              item: selectedOrderList.value,
              list: batchExpressList.value,
              onChangeIntShipBach: handlechangeIntShipBach
            }, null, 8, ["config", "isTiktok", "item", "list"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ], 2),
    _createVNode(ChooseSetAdditon, {
      "show-zh": (_unref(moreWarehouseConfig)?.deliveryType !== 'ONLY_JP'),
      showKr: _unref(isMultiStore)(),
      showJp: _unref(openMoreWare) || _unref(wareOnlyJp),
      visible: chooseVisible.value,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((chooseVisible).value = $event)),
      onSuccess: batchEditAddition
    }, null, 8, ["show-zh", "showKr", "showJp", "visible"])
  ]))
}
}

})